/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 80);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Common", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.Common;
  }
});
Object.defineProperty(exports, "CommonTester", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.CommonTester;
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.createStore;
  }
});

var _wsmCommonData = __webpack_require__(77);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_MODAL_SETTINGS = exports.SET_RENDER_SETTINGS = exports.SET_WIDGET_INFO = exports.SET_MY_CARS_SAVED = exports.SET_MY_CARS_ENABLED = exports.SET_FYUSE_UID = exports.SET_MEDIA = void 0;
// This file should only contain action type constants.
var SET_MEDIA = 'SET_MEDIA';
exports.SET_MEDIA = SET_MEDIA;
var SET_FYUSE_UID = 'SET_FYUSE_UID';
exports.SET_FYUSE_UID = SET_FYUSE_UID;
var SET_MY_CARS_ENABLED = 'SET_MY_CARS_ENABLED';
exports.SET_MY_CARS_ENABLED = SET_MY_CARS_ENABLED;
var SET_MY_CARS_SAVED = 'SET_MY_CARS_SAVED';
exports.SET_MY_CARS_SAVED = SET_MY_CARS_SAVED;
var SET_WIDGET_INFO = 'SET_WIDGET_INFO';
exports.SET_WIDGET_INFO = SET_WIDGET_INFO;
var SET_RENDER_SETTINGS = 'SET_RENDER_SETTINGS';
exports.SET_RENDER_SETTINGS = SET_RENDER_SETTINGS;
var SET_MODAL_SETTINGS = 'SET_MODAL_SETTINGS';
exports.SET_MODAL_SETTINGS = SET_MODAL_SETTINGS;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = ReactBootstrap;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(4);

var _common = __webpack_require__(2);

__webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Arrow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Arrow, _React$Component);

  function Arrow() {
    _classCallCheck(this, Arrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(Arrow).apply(this, arguments));
  }

  _createClass(Arrow, [{
    key: "render",
    value: function render() {
      var _this = this;

      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var labels = _ref.labels;
          var _this$props = _this.props,
              direction = _this$props.direction,
              classes = _this$props.classes,
              onClickEvent = _this$props.onClickEvent;
          var type = direction === 'right' ? labels.get('NEXT') : labels.get('PREVIOUS');
          var arrowKey = direction === 'right' ? labels.get('RIGHT_ARROW') : labels.get('LEFT_ARROW');
          var buttonClasses = ['btn-carousel', 'p-0'];

          if (classes) {
            buttonClasses = _toConsumableArray(buttonClasses).concat(_toConsumableArray(classes));
          }

          var iconClasses = ['ddc-icon', 'ddc-icon-carousel-arrow', "ddc-icon-carousel-arrow-".concat(direction), 'd-block'];
          return _react.default.createElement(_reactBootstrap.Button, {
            className: buttonClasses.join(' '),
            onClick: onClickEvent.bind(_this),
            bsStyle: null,
            title: "".concat(type, " (").concat(arrowKey, ")")
          }, _react.default.createElement("i", {
            className: iconClasses.join(' ')
          }));
        }
      });
    }
  }]);

  return Arrow;
}(_react.default.Component);

Arrow.defaultProps = {
  classes: []
};
Arrow.propTypes = {
  direction: _propTypes.default.string.isRequired,
  onClickEvent: _propTypes.default.func.isRequired,
  classes: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = Arrow;
exports.default = _default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(4);

var _common = __webpack_require__(2);

__webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MyCarsButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MyCarsButton, _React$Component);

  function MyCarsButton() {
    _classCallCheck(this, MyCarsButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(MyCarsButton).apply(this, arguments));
  }

  _createClass(MyCarsButton, [{
    key: "trackEvent",
    value: function trackEvent(action) {
      this.props.trackGa({
        element: 'Favorite button',
        result: "Favorite ".concat(action),
        widgetState: 'default'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          savedVehicles = _this$props.myCars.savedVehicles,
          myCarsSaveButtonClasses = _this$props.myCarsSaveButtonClasses;
      var component = null;

      if (savedVehicles) {
        var _this$props2 = this.props,
            uuid = _this$props2.uuid,
            transparent = _this$props2.transparent;
        var containerClasses = ['mycars-buttons'];

        if (!transparent) {
          containerClasses.push('mr-4');
        }

        var classes = new Set(['btn-mycars-save', 'd-flex', 'align-items-center', 'btn-no-decoration', 'btn-small', //	myCars classes are used to attach remove/save vehicle listeners
        //	alternates with 'mycars-saved-btn' which signifies a click should remove the saved vehicle
        'mycars-save-btn']);

        if (transparent) {
          classes.add('p-4 pr-3');
        }

        if (myCarsSaveButtonClasses) {
          classes.add(myCarsSaveButtonClasses);
        }

        var savedVehicle = savedVehicles ? savedVehicles.find(function (vehicle) {
          return vehicle.itemUUID === uuid;
        }) : null;
        var buttonLabel = savedVehicle ? 'SAVED' : 'SAVE';
        var action = savedVehicle ? 'removed' : 'added';
        var dataMessage = savedVehicle ? '#ddc-mobile-mycars-remove' : '#ddc-mobile-mycars';
        var dataAction = savedVehicle ? 'remove' : 'save';

        if (savedVehicle) {
          classes.add('saved'); // alternated save / saved class to trigger removeVehicle logic on click

          classes.delete('mycars-save-btn');
          classes.add('mycars-saved-btn');
        }

        var dataAttributes = {
          'data-id': uuid,
          'data-message': dataMessage
        };
        dataAttributes["data-mycars-".concat(dataAction)] = ''; // format-js puts the closing tag of the <path> element on the wrong line
        // then the linter fails because this is invalid. TODO: Have Syntropy fix this

        /* eslint-disable react/jsx-closing-bracket-location */

        component = _react.default.createElement(_common.Common, {
          render: function render(_ref) {
            var labels = _ref.labels;
            var iconSize = '24';
            return _react.default.createElement("div", {
              className: containerClasses.join(' ')
            }, _react.default.createElement(_reactBootstrap.Button, _extends({
              className: _toConsumableArray(classes).join(' '),
              bsStyle: transparent ? 'link' : 'default',
              onClick: function onClick() {
                _this.trackEvent(action);
              }
            }, dataAttributes), _react.default.createElement("svg", {
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              width: iconSize,
              height: iconSize,
              viewBox: "0 0 24 24",
              className: "ddc-icon-mycars-favorite"
            }, _react.default.createElement("path", {
              d: "M18.2,22L12,18.2L5.8,22L7,14.5l-5-5l6.9-1.2L12,2l3.2,6.2L22,9.5l-5,5L18.2,22z"
            })), !transparent && _react.default.createElement("span", {
              className: "pl-2"
            }, labels.get(buttonLabel))));
          }
        });
      }

      return component;
    }
  }]);

  return MyCarsButton;
}(_react.default.Component);

MyCarsButton.propTypes = {
  uuid: _propTypes.default.string.isRequired,
  transparent: _propTypes.default.bool,
  trackGa: _propTypes.default.func.isRequired,
  myCars: _propTypes.default.shape({
    savedVehicles: _propTypes.default.array
  }).isRequired,
  myCarsSaveButtonClasses: _propTypes.default.string
};
MyCarsButton.defaultProps = {
  transparent: false,
  myCarsSaveButtonClasses: ''
};
var _default = MyCarsButton;
exports.default = _default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ['beforeChange', 'afterChange', 'imageLoadComplete', 'resize', 'gettingData', 'mouseUsed', 'initialZoomIn', 'initialZoomInEnd', 'initialZoomOut', 'initialZoomOutEnd', 'parseVerticalMargin', 'close', 'unbindEvents', 'destroy', 'updateScrollOffset', 'preventDragEvent', 'shareLinkClick'];
exports.default = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = exports.buildUrlWithParams = exports.getSearchRO = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/* eslint-disable func-names */

/*
 * This search request obj gets passed to the vcda module in ws-scripts
 * to make parallel request to each service
 */
var getSearchRO = function getSearchRO(vehicleId) {
  var additionalMediaProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return {
    media: {
      uuid: vehicleId,
      select: ['images', 'videos'].concat(_toConsumableArray(additionalMediaProperties))
    },
    vehicle: {
      uuid: vehicleId
    }
  };
};
/*
 * Takes a URL and a map of URL parameters, and combines them into a full URL.
 */


exports.getSearchRO = getSearchRO;

var buildUrlWithParams = function buildUrlWithParams(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();

  if (!params.size) {
    return url;
  }

  var paramString = Array.from(params, function (keyValuePair) {
    return keyValuePair.map(encodeURIComponent).join('=');
  }).join('&');
  return "".concat(url, "?").concat(paramString);
}; // Underscore's debounce function


exports.buildUrlWithParams = buildUrlWithParams;

var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    // eslint-disable-next-line one-var
    var context = this,
        args = arguments; // eslint-disable-line prefer-rest-params

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

exports.debounce = debounce;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(52);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Carousel = __webpack_require__(67);

module.exports = Carousel;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(5);

var _reactHotLoader = __webpack_require__(69);

var _Widget = _interopRequireDefault(__webpack_require__(32));

var _store = __webpack_require__(50);

var _widgetComponents = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React hydrate bound to the redux store
 * - Set up hot reloading
 *
 * NOTE: The eslint-disable-lines are needed because this file won't lint
 * when it's in the ws-scripts repo because those files only exist in the
 * widget. It's safe because the entire application won't work if those
 * weren't really resolved. It would be really apparent quickly.
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		WS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
// eslint-disable-line import/no-unresolved
var getFlag = function getFlag(name, defaultValue) {
  if (!window.DDC || !window.DDC.Flags) {
    return defaultValue;
  }

  return window.DDC.Flags[name];
};

var serveBundleFromClientSite = getFlag('serve-osiris-bundle-from-clientsite', false) === true;
var stateParentKey = serveBundleFromClientSite ? 'WS' : 'OSIRIS';

var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC[stateParentKey] || !window.DDC[stateParentKey].state || !window.DDC[stateParentKey].state[widgetName]) {
    return {};
  }

  return window.DDC[stateParentKey].state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var renderWidget = function renderWidget(WidgetComponent, renderFunc, store, widgetId) {
  renderFunc(_react.default.createElement(_reactHotLoader.AppContainer, null, (0, _widgetComponents.getWidgetComponents)(WidgetComponent, store, widgetId)), document.getElementById("".concat(widgetId, "-app-root")));
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-vehicle-media');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store;
    renderWidget(_Widget.default, _reactDom.hydrate, store, widgetId); // We've initialized. We don't need to keep this data around anymore.
    // Deleting it ensures that we don't accidentally reinitialize later.

    if (serveBundleFromClientSite) {
      delete widgetStates[widgetId];
    }
  });
};

if (serveBundleFromClientSite) {
  initializeWidgets();
} else if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

if (false) {
  module.hot.accept('../containers/Widget', function () {
    Object.keys(widgetIdToStore).forEach(function (widgetId) {
      var store = widgetIdToStore[widgetId];

      var ReloadedWidget = require('../containers/Widget').default; // eslint-disable-line import/no-unresolved


      renderWidget(ReloadedWidget, _reactDom.render, store, widgetId);
    });
  });
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setModalSettings = setModalSettings;

var _types = __webpack_require__(3);

function setModalSettings(data) {
  return {
    type: _types.SET_MODAL_SETTINGS,
    payload: data
  };
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMyCarsEnabled = setMyCarsEnabled;
exports.setMyCarsSavedVehicles = setMyCarsSavedVehicles;

var _types = __webpack_require__(3);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function setMyCarsEnabled(enabled) {
  return {
    type: _types.SET_MY_CARS_ENABLED,
    payload: enabled
  };
}

function setMyCarsSavedVehicles(data) {
  return {
    type: _types.SET_MY_CARS_SAVED,
    payload: _toConsumableArray(data)
  };
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRenderSettings = setRenderSettings;

var _types = __webpack_require__(3);

function setRenderSettings(data) {
  return {
    type: _types.SET_RENDER_SETTINGS,
    payload: data
  };
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(4);

var _common = __webpack_require__(2);

var _lodash = _interopRequireDefault(__webpack_require__(65));

var _utility = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Cta =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Cta, _React$Component);

  function Cta() {
    _classCallCheck(this, Cta);

    return _possibleConstructorReturn(this, _getPrototypeOf(Cta).apply(this, arguments));
  }

  _createClass(Cta, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // required to make the cta button work on mobile
      var ddcSlideIn = (0, _lodash.default)(window, 'DDC.mobile.slidein', undefined);

      if (this.props.transparent && ddcSlideIn) {
        ddcSlideIn.init();
      }
    }
  }, {
    key: "trackEvent",
    value: function trackEvent() {
      this.props.trackGa({
        element: 'Share button',
        result: 'Opened share modal',
        widgetState: 'default'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          href = _this$props.href,
          icon = _this$props.icon,
          label = _this$props.label,
          params = _this$props.params,
          dialog = _this$props.dialog,
          dialogTitle = _this$props.dialogTitle,
          dialogWidth = _this$props.dialogWidth,
          transparent = _this$props.transparent;
      var url = (0, _utility.buildUrlWithParams)(href, params);
      var dataAttributes = {
        'data-href': url,
        href: url
      };
      var ctaClassArray = ['cta'];

      if (!transparent) {
        ctaClassArray.push('mr-4');
      }

      var buttonClassArray = ['align-items-center', 'd-flex', 'btn-share', 'btn-no-decoration', 'btn-small'];

      if (dialog) {
        buttonClassArray.push('dialog');
      }

      if (transparent) {
        buttonClassArray.push('px-3 py-4');
      }

      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var labels = _ref.labels;

          if (dialog) {
            // On mobile if you omit data-title the slidein does not work.
            // We provide a backup in case the dialogTitle preference is blank.
            var labelAlias = dialogTitle === '' ? label : dialogTitle;
            dataAttributes['data-title'] = labels.get(labelAlias);
            dataAttributes.rel = 'nofollow';
            dataAttributes['data-width'] = dialogWidth;
          }

          return _react.default.createElement("div", {
            className: ctaClassArray.join(' ')
          }, _react.default.createElement(_reactBootstrap.Button, _extends({
            className: buttonClassArray.join(' '),
            bsStyle: transparent ? 'link' : 'default',
            onClick: function onClick() {
              _this.trackEvent();
            }
          }, dataAttributes), icon, _react.default.createElement("span", {
            className: "pl-1".concat(transparent ? ' sr-only' : '')
          }, labels.get(label))));
        }
      });
    }
  }]);

  return Cta;
}(_react.default.Component);

Cta.propTypes = {
  href: _propTypes.default.string.isRequired,
  icon: _propTypes.default.element,
  label: _propTypes.default.string.isRequired,
  params: _propTypes.default.shape({}),
  dialog: _propTypes.default.bool.isRequired,
  dialogTitle: _propTypes.default.string,
  dialogWidth: _propTypes.default.string,
  transparent: _propTypes.default.bool.isRequired,
  trackGa: _propTypes.default.func.isRequired
};
Cta.defaultProps = {
  params: {},
  dialogTitle: '',
  dialogWidth: '300',
  icon: _react.default.createElement("svg", null)
};
var _default = Cta;
exports.default = _default;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

__webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DDCPlayerVideoComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DDCPlayerVideoComponent, _React$Component);

  function DDCPlayerVideoComponent() {
    _classCallCheck(this, DDCPlayerVideoComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DDCPlayerVideoComponent).apply(this, arguments));
  }

  _createClass(DDCPlayerVideoComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof DDC !== 'undefined') {
        if (this.props.video && DDC.modules && DDC.modules.video && typeof $ !== 'undefined') {
          /* eslint no-undef: 0 */
          $(document).trigger('modulesRefresh', DDC.modules.video);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.video) {
        var _this$props = this.props,
            viewportWidth = _this$props.viewportWidth,
            viewportHeight = _this$props.viewportHeight,
            _this$props$video = _this$props.video,
            id = _this$props$video.id,
            src = _this$props$video.src,
            _this$props$widgetInf = _this$props.widgetInfo,
            accountId = _this$props$widgetInf.accountId,
            deviceType = _this$props$widgetInf.deviceType,
            videoIsOpen = _this$props.modalSettings.videoIsOpen,
            mobileOrientationIsPortrait = _this$props.mobileOrientationIsPortrait;
        var videoWidth = viewportWidth < 920 ? viewportWidth : 920;

        if (!mobileOrientationIsPortrait && /mobile/gi.test(deviceType)) {
          videoWidth = viewportHeight;
        }

        var baseClassNames = ['h-100', 'd-flex', 'justify-content-center', 'align-items-center'];
        var wrapperClassNames = new Set(baseClassNames.concat(['video-container', 'py-5']));
        var playerClassNames = baseClassNames.concat(['ddcPlayer-holder']);

        if (!videoIsOpen) {
          wrapperClassNames.add('hide');
          wrapperClassNames.delete('d-flex');
        }

        return _react.default.createElement("div", {
          className: _toConsumableArray(wrapperClassNames).join(' ')
        }, _react.default.createElement("div", {
          id: "video-".concat(id),
          className: playerClassNames.join(' '),
          "data-ddcplayerinfo": "".concat(encodeURIComponent(src), "-").concat(videoWidth, "-").concat(Math.round(videoWidth * 0.7)),
          "data-accountid": "".concat(accountId),
          "data-useprepostroll": "false",
          "data-autoplay": "false"
        }));
      } // No video - nothing to see here


      return null;
    }
  }]);

  return DDCPlayerVideoComponent;
}(_react.default.Component);

DDCPlayerVideoComponent.propTypes = {
  widgetInfo: _propTypes.default.shape({
    accountId: _propTypes.default.string,
    deviceType: _propTypes.default.string
  }).isRequired,
  viewportWidth: _propTypes.default.number.isRequired,
  viewportHeight: _propTypes.default.number.isRequired,
  video: _propTypes.default.shape({
    id: _propTypes.default.number,
    src: _propTypes.default.string
  }),
  modalSettings: _propTypes.default.shape({
    videoIsOpen: _propTypes.default.bool
  }).isRequired,
  mobileOrientationIsPortrait: _propTypes.default.bool.isRequired
};
DDCPlayerVideoComponent.defaultProps = {
  video: {}
};
var _default = DDCPlayerVideoComponent;
exports.default = _default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

__webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var IFrameVideoComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IFrameVideoComponent, _React$Component);

  function IFrameVideoComponent() {
    _classCallCheck(this, IFrameVideoComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(IFrameVideoComponent).apply(this, arguments));
  }

  _createClass(IFrameVideoComponent, [{
    key: "render",
    value: function render() {
      if (this.props.video) {
        var _this$props = this.props,
            _this$props$video = _this$props.video,
            src = _this$props$video.src,
            provider = _this$props$video.provider,
            accountId = _this$props.widgetInfo.accountId,
            videoIsOpen = _this$props.modalSettings.videoIsOpen;
        var wrapperClassNames = new Set(['h-100', 'd-flex', 'justify-content-center', 'align-items-center', 'video-container', 'py-5']);
        var playerClassNames = ['d-flex', 'justify-content-center', 'align-items-center'];

        if (!videoIsOpen) {
          wrapperClassNames.add('hide');
          wrapperClassNames.delete('d-flex');
        }

        return _react.default.createElement("div", {
          className: _toConsumableArray(wrapperClassNames).join(' ')
        }, _react.default.createElement("iframe", {
          src: "".concat(src),
          title: "dcpaisIframe",
          className: playerClassNames.join(' '),
          "data-accountid": "".concat(accountId),
          "data-provider": "".concat(provider)
        }));
      } // No video - nothing to see here


      return null;
    }
  }]);

  return IFrameVideoComponent;
}(_react.default.Component);

IFrameVideoComponent.propTypes = {
  widgetInfo: _propTypes.default.shape({
    accountId: _propTypes.default.string
  }).isRequired,
  video: _propTypes.default.shape({
    src: _propTypes.default.string,
    provider: _propTypes.default.string
  }).isRequired,
  modalSettings: _propTypes.default.shape({
    videoIsOpen: _propTypes.default.bool
  }).isRequired
};
var _default = IFrameVideoComponent;
exports.default = _default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LoadingSpinner =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoadingSpinner, _React$Component);

  function LoadingSpinner() {
    _classCallCheck(this, LoadingSpinner);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingSpinner).apply(this, arguments));
  }

  _createClass(LoadingSpinner, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "loading-wrapper d-flex justify-content-center align-items-center",
        style: {
          height: '60vh'
        }
      }, _react.default.createElement(_reactBootstrap.Image, {
        src: "https://static.dealer.com/v9/media/images/ajax-loaders/v1/white-ajax-loader-2.gif",
        width: "32",
        height: "32"
      }));
    }
  }]);

  return LoadingSpinner;
}(_react.default.Component);

var _default = LoadingSpinner;
exports.default = _default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(5));

var _reactBootstrap = __webpack_require__(4);

var _MyCarsButton = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SingleImage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SingleImage, _React$Component);

  function SingleImage(props) {
    var _this;

    _classCallCheck(this, SingleImage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleImage).call(this, props));
    _this.el = document.createElement('div');

    var _document$querySelect = document.querySelectorAll('.ddc-vehicle-image-mini'),
        _document$querySelect2 = _toArray(_document$querySelect),
        container = _document$querySelect2[0],
        _otherContainers = _document$querySelect2.slice(1);

    _this.containerEl = container;
    return _this;
  }

  _createClass(SingleImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.containerEl) {
        this.containerEl.appendChild(this.el);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.containerEl) {
        this.containerEl.removeChild(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var singleImageProps = {
        src: this.props.image,
        responsive: true
      };

      if (this.props.onClick) {
        singleImageProps.onClick = this.props.onClick;
        singleImageProps.role = 'button';
      } // Use a portal to render the image into the sidebar


      return _reactDom.default.createPortal(_react.default.createElement("div", null, _react.default.createElement(_MyCarsButton.default, {
        transparent: true,
        uuid: this.props.uuid,
        iconSize: "large",
        trackGa: this.props.trackGa,
        myCars: this.props.myCars,
        myCarsSaveButtonClasses: "position-absolute"
      }), _react.default.createElement(_reactBootstrap.Image, singleImageProps)), this.el);
    }
  }]);

  return SingleImage;
}(_react.default.Component);

SingleImage.propTypes = {
  image: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func,
  uuid: _propTypes.default.string.isRequired,
  trackGa: _propTypes.default.func.isRequired,
  myCars: _propTypes.default.shape({
    savedVehicles: _propTypes.default.arrayOf(_propTypes.default.shape())
  }).isRequired
};
SingleImage.defaultProps = {
  onClick: null
};
var _default = SingleImage;
exports.default = _default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(4);

var _nukaCarousel = _interopRequireDefault(__webpack_require__(12));

var _Arrow = _interopRequireDefault(__webpack_require__(6));

var _imageResizer = _interopRequireDefault(__webpack_require__(33));

__webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var THREE_UP_RATIO = 1.2;

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));
    var innerWidth = props.innerWidth,
        currentIndex = props.currentIndex;
    _this.state = {
      loadedIndex: 3,
      viewportWidth: innerWidth,
      currentIndex: currentIndex || 0
    };
    return _this;
  }

  _createClass(Slider, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Set a unique prop for image width so that images don't
      // repaint when the state updates the innerWidth property.
      var newState = _objectSpread({}, this.state);

      var innerWidth = nextProps.innerWidth;

      if (!newState.viewportWidth) {
        newState.viewportWidth = innerWidth;
      }

      if (newState.currentIndex !== nextProps.currentIndex) {
        newState.currentIndex = nextProps.currentIndex; // if index changes, assume gallery was interacted with, load all images

        newState.loadedIndex = nextProps.images.length;
      }

      this.setState(newState);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this2 = this;

      // don't care about the method changes (these should maybe be updated to dispatched actions)
      var ignoreProps = ['onCurrentIndexChange', 'onPhotoClick', 'trackGa'];
      var nextPropsKeys = Object.keys(nextProps);
      var hasNewProps = false;
      nextPropsKeys.forEach(function (propKey) {
        if (ignoreProps.indexOf(propKey) === -1 && nextProps[propKey] !== _this2.props[propKey]) {
          hasNewProps = true;
        }
      });
      var nextStateKeys = Object.keys(nextState);
      var hasNewState = false;
      nextStateKeys.forEach(function (stateKey) {
        if (stateKey !== 'currentIndex' && nextState[stateKey] !== _this2.state[stateKey]) {
          hasNewState = true;
        }
      });
      return hasNewProps || hasNewState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          currentIndex = _this$state.currentIndex,
          viewportWidth = _this$state.viewportWidth;
      var _this$props = this.props,
          innerWidth = _this$props.innerWidth,
          threeUpDisplay = _this$props.threeUpDisplay,
          imageMode = _this$props.imageMode,
          responsiveImage = _this$props.responsiveImage,
          onPhotoClick = _this$props.onPhotoClick,
          trackGa = _this$props.trackGa,
          images = _this$props.images,
          deviceType = _this$props.widgetInfo.deviceType,
          onCurrentIndexChange = _this$props.onCurrentIndexChange;
      var numSlides = images.length;
      var slidesToShow = threeUpDisplay ? 3 : 1;
      var sliderProps = {
        dots: false,
        wrapAround: true,
        speed: 500,
        slideIndex: currentIndex,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        slideWidth: threeUpDisplay ? THREE_UP_RATIO : 1,
        ref: 'slider',
        beforeSlide: function beforeSlide(current, newIndex) {
          if (newIndex !== _this3.props.currentIndex) {
            onCurrentIndexChange(newIndex);
          }
        },
        // Only show arrows if needed
        decorators: (numSlides > 2 || !threeUpDisplay && numSlides > 1) && /desktop/gi.test(deviceType) ? [{
          component: function component(arrowProps) {
            return _react.default.createElement(_Arrow.default, {
              direction: "right",
              onClickEvent: function onClickEvent() {
                arrowProps.nextSlide();
                trackGa({
                  element: 'Photo Carousel Next button',
                  result: 'Move to next photo'
                });
              }
            });
          },
          position: 'CenterRight',
          style: {
            right: 16
          }
        }, {
          component: function component(arrowProps) {
            return _react.default.createElement(_Arrow.default, {
              direction: "left",
              classes: null,
              type: "prev",
              onClickEvent: function onClickEvent() {
                arrowProps.previousSlide();
                trackGa({
                  element: 'Photo Carousel Previous button',
                  result: 'Move to previous photo'
                });
              }
            });
          },
          position: 'CenterLeft',
          style: {
            left: 16
          }
        }] : []
      };

      var photoClickHandler = function photoClickHandler(index) {
        var touchObject = _this3.refs.slider.touchObject;

        if (Object.keys(touchObject).length === 0) {
          onPhotoClick(index);
        }
      };

      var classes = [];

      if (numSlides === 1 && !imageMode) {
        classes.push('single-slide');
      }

      var blankImage = 'https://static.dealer.com/images/blank.gif';
      var firstImageSrc = blankImage;
      var slides = images.map(function (image) {
        var id = image.id,
            src = image.src;
        var loaded = id <= _this3.state.loadedIndex;
        var imageSrc = blankImage;

        if (loaded) {
          imageSrc = (0, _imageResizer.default)(threeUpDisplay, viewportWidth, src, THREE_UP_RATIO);
        } else {
          classes.push('d-none');
        } // Grab the first image for the background


        if (firstImageSrc === blankImage) {
          firstImageSrc = imageSrc;
        }

        var style = {
          background: "url(".concat(imageSrc, ") no-repeat center/cover")
        };
        var imageComponent;

        if (imageMode) {
          imageComponent = _react.default.createElement(_reactBootstrap.Image, {
            key: id,
            src: imageSrc,
            className: classes.join(' '),
            onLoad: function onLoad() {
              // Fire a resize event to force a redraw of the carousel so it can recalculate the height
              if (id === 0) {
                window.dispatchEvent(new Event('resize'));
              }
            },
            onClick: function onClick() {
              photoClickHandler(id);
            },
            role: "button",
            tabIndex: id,
            onKeyDown: function onKeyDown(e) {
              // If the user tabs to a slide and hits enter, open the modal
              if (e.key === 'Enter' || e.keyCode === 13) {
                onPhotoClick(id);
              }
            }
          });

          if (!responsiveImage && !threeUpDisplay) {
            // Wrap component to use the image as its own background
            imageComponent = _react.default.createElement("div", {
              className: "blurred-container",
              key: id
            }, _react.default.createElement("div", {
              style: style,
              className: "blurred-background"
            }), imageComponent);
          }
        } else {
          imageComponent = _react.default.createElement("div", {
            key: id,
            style: style,
            className: classes.join(' '),
            onClick: function onClick() {
              photoClickHandler(id);
            },
            role: "button",
            tabIndex: id,
            onKeyDown: function onKeyDown(e) {
              // If the user tabs to a slide and hits enter, open the modal
              if (e.key === 'Enter' || e.keyCode === 13) {
                onPhotoClick(id);
              }
            }
          });
        }

        return imageComponent;
      });
      var carouselClasses = ['photo-carousel', !imageMode || !innerWidth ? 'background-mode' : 'image-mode', threeUpDisplay ? 'add-border' : ''];
      var carouselComponent;

      if (!responsiveImage && threeUpDisplay) {
        // Use first image for background
        var carouselStyle = {
          background: "url(".concat(firstImageSrc, ") no-repeat right/contain")
        };
        carouselComponent = // Add blurred background
        _react.default.createElement("div", {
          className: "blurred-container"
        }, _react.default.createElement("div", {
          style: carouselStyle,
          className: "blurred-background"
        }), _react.default.createElement("div", {
          className: carouselClasses.join(' ')
        }, _react.default.createElement(_nukaCarousel.default, sliderProps, slides)));
      } else {
        carouselComponent = _react.default.createElement("div", {
          className: carouselClasses.join(' ')
        }, _react.default.createElement(_nukaCarousel.default, sliderProps, slides));
      }

      return carouselComponent;
    }
  }]);

  return Slider;
}(_react.default.Component);

Slider.defaultProps = {
  currentIndex: 0,
  nextSlide: function nextSlide() {},
  previousSlide: function previousSlide() {},
  onPhotoClick: function onPhotoClick() {}
};
Slider.propTypes = {
  images: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    src: _propTypes.default.string,
    thumbnail: _propTypes.default.string
  })).isRequired,
  // renderSettings
  innerHeight: _propTypes.default.number.isRequired,
  innerWidth: _propTypes.default.number.isRequired,
  imageMode: _propTypes.default.bool.isRequired,
  responsiveImage: _propTypes.default.bool.isRequired,
  threeUpDisplay: _propTypes.default.bool.isRequired,
  currentIndex: _propTypes.default.number,
  onCurrentIndexChange: _propTypes.default.func.isRequired,
  nextSlide: _propTypes.default.func,
  previousSlide: _propTypes.default.func,
  trackGa: _propTypes.default.func.isRequired,
  onPhotoClick: _propTypes.default.func,
  widgetInfo: _propTypes.default.shape({
    deviceType: _propTypes.default.string
  }).isRequired
};
var _default = Slider;
exports.default = _default;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

__webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Homenet360Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Homenet360Component, _React$Component);

  function Homenet360Component() {
    _classCallCheck(this, Homenet360Component);

    return _possibleConstructorReturn(this, _getPrototypeOf(Homenet360Component).apply(this, arguments));
  }

  _createClass(Homenet360Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var trackGa = this.props.trackGa;

      if (typeof FYU !== 'undefined') {
        var fyuseUid = this.props.fyuseUid;

        if (fyuseUid && fyuseUid.length) {
          /* eslint no-undef: 0 */
          // Specs: http://fyu.se/api/specs/web/viewer.html
          // Loading states: init, load, complete, & error
          FYU.add(fyuseUid, 'spin360', {
            autoplay: 0,
            zoom: 1,
            preload: 1,
            nologo: 1,
            nooverlay: 0,
            fullscreen: 0
          }).on('load', function () {
            // Attach tracking event handlers
            var spinCanvas = document.querySelector('.fyu-renderer .fyu-canvas');

            if (spinCanvas) {
              spinCanvas.addEventListener('mousedown', function () {
                return trackGa({
                  element: 'Homenet 360 Spin Content',
                  result: 'Clicks or rotates content',
                  widgetState: 'Gallery Modal'
                });
              }); // Mobile

              spinCanvas.addEventListener('touchstart', function () {
                return trackGa({
                  element: 'Homenet 360 Spin Content',
                  result: 'Clicks or rotates content',
                  widgetState: 'Gallery Modal'
                });
              });
            }

            var tagIcon = document.querySelector('a.fyubtn.tags');

            if (tagIcon) {
              tagIcon.addEventListener('mousedown', function () {
                return trackGa({
                  element: 'Homenet 360 Tag Button',
                  result: 'Toggles thumbnail links to tagged content',
                  widgetState: 'Gallery Modal'
                });
              });
            }

            var tagsOverlay = document.querySelector('.fyuse_tags_container');

            if (tagsOverlay) {
              tagsOverlay.addEventListener('mousedown', function () {
                return trackGa({
                  element: 'Homenet 360 Spin Content',
                  result: 'Clicks or rotates content showing tag thumbnails',
                  widgetState: 'Gallery Modal'
                });
              }); // Mobile

              tagsOverlay.addEventListener('touchstart', function () {
                return trackGa({
                  element: 'Homenet 360 Spin Content',
                  result: 'Clicks or rotates content showing tag thumbnails',
                  widgetState: 'Gallery Modal'
                });
              });
            }

            var container = document.querySelector('.fyu_container');

            if (container) {
              container.addEventListener('dblclick', function () {
                return trackGa({
                  element: 'Homenet 360 Spin Content',
                  result: 'Zoom In/Out',
                  widgetState: 'Gallery Modal'
                });
              });
            }
          }).on('complete', function () {
            // Wait until tags are loaded
            var taggedContent = document.querySelectorAll('.fyuse_tag a');

            if (taggedContent) {
              taggedContent.forEach(function (e) {
                e.addEventListener('mousedown', function () {
                  return trackGa({
                    element: 'Homenet 360 Tag',
                    result: 'Displays tagged content (photo/spin)',
                    widgetState: 'Gallery Modal'
                  });
                });
              });
            }
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // This is a hack to trigger a resize event to get the canvas to redraw
      // after clicking away from it and back again
      if (prevProps.modalSettings.spin360IsOpen !== this.props.modalSettings.spin360IsOpen && this.props.modalSettings.spin360IsOpen) {
        var evt = window.document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          spin360IsOpen = _this$props.modalSettings.spin360IsOpen,
          fyuseUid = _this$props.fyuseUid;

      if (fyuseUid && fyuseUid.length) {
        var baseClassNames = ['h-100', 'd-flex', 'justify-content-center', 'align-items-center'];
        var wrapperClassNames = new Set(baseClassNames.concat(['spin360-container', 'py-5']));

        if (!spin360IsOpen) {
          wrapperClassNames.add('hide');
          wrapperClassNames.delete('d-flex');
        } else {
          wrapperClassNames.delete('hide');
          wrapperClassNames.add('d-flex');
        }

        return _react.default.createElement("div", {
          className: _toConsumableArray(wrapperClassNames).join(' ')
        }, _react.default.createElement("div", {
          id: "spin360",
          className: "fyu_container fyu_horizontal"
        }));
      } else {
        return null;
      }
    }
  }]);

  return Homenet360Component;
}(_react.default.Component);

Homenet360Component.propTypes = {
  modalSettings: _propTypes.default.shape({
    videoIsOpen: _propTypes.default.bool,
    spin360IsOpen: _propTypes.default.bool
  }).isRequired,
  fyuseUid: _propTypes.default.string.isRequired,
  trackGa: _propTypes.default.func.isRequired
};
var _default = Homenet360Component;
exports.default = _default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CommonButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CommonButton, _React$Component);

  function CommonButton() {
    _classCallCheck(this, CommonButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(CommonButton).apply(this, arguments));
  }

  _createClass(CommonButton, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_reactBootstrap.Button, {
        bsStyle: null,
        bsSize: this.props.bsSize,
        className: "btn-pswp btn-link mt-1 text-white ".concat(this.props.buttonClasses),
        onClick: this.props.onClick
      }, _react.default.createElement("i", {
        className: ['ddc-icon', this.props.iconClass, 'text-white'].join(' ')
      }), ' ', _react.default.createElement("span", null, this.props.buttonName));
    }
  }]);

  return CommonButton;
}(_react.default.Component);

CommonButton.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  iconClass: _propTypes.default.string.isRequired,
  buttonName: _propTypes.default.string.isRequired,
  bsSize: _propTypes.default.string.isRequired,
  buttonClasses: _propTypes.default.string.isRequired
};
var _default = CommonButton;
exports.default = _default;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CommonLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CommonLink, _React$Component);

  function CommonLink() {
    _classCallCheck(this, CommonLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(CommonLink).apply(this, arguments));
  }

  _createClass(CommonLink, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        role: "presentation",
        className: "d-inline-block mx-3",
        onClick: this.props.onClick,
        onFocus: function onFocus() {}
      }, _react.default.createElement("a", {
        href: "#",
        className: "text-link-muted d-inline-flex align-items-center"
      }, _react.default.createElement("i", {
        className: "ddc-icon ".concat(this.props.iconClass, " ").concat(this.props.galleryIconColor, " mr-3 align-middle")
      }), _react.default.createElement("span", null, this.props.linkName)));
    }
  }]);

  return CommonLink;
}(_react.default.Component);

CommonLink.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  iconClass: _propTypes.default.string.isRequired,
  galleryIconColor: _propTypes.default.string.isRequired,
  linkName: _propTypes.default.string.isRequired
};
var _default = CommonLink;
exports.default = _default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(2);

var _events = _interopRequireDefault(__webpack_require__(8));

var _PhotoSwipeThumbnails = _interopRequireDefault(__webpack_require__(30));

var _Photoswipe = _interopRequireDefault(__webpack_require__(31));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PhotoSwipeGallery =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PhotoSwipeGallery, _React$Component);

  function PhotoSwipeGallery() {
    _classCallCheck(this, PhotoSwipeGallery);

    return _possibleConstructorReturn(this, _getPrototypeOf(PhotoSwipeGallery).apply(this, arguments));
  }

  _createClass(PhotoSwipeGallery, [{
    key: "goToPhoto",
    value: function goToPhoto(itemIndex, e) {
      if (e) {
        e.preventDefault();
      }

      this.pswpComponent.photoSwipe.goTo(itemIndex);
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          currentIndex = _this$props.currentIndex,
          images = _this$props.images,
          updateModalSettings = _this$props.updateModalSettings,
          trackGa = _this$props.trackGa,
          modalSettings = _this$props.modalSettings,
          viewportWidth = _this$props.viewportWidth,
          viewportHeight = _this$props.viewportHeight,
          widgetInfo = _this$props.widgetInfo,
          video = _this$props.video,
          other = _objectWithoutProperties(_this$props, ["currentIndex", "images", "updateModalSettings", "trackGa", "modalSettings", "viewportWidth", "viewportHeight", "widgetInfo", "video"]);

      var isDesktop = /desktop/gi.test(widgetInfo.deviceType);
      var eventProps = {};

      for (var i = 0; i < _events.default.length; i++) {
        if (other[_events.default[i]]) {
          eventProps[_events.default[i]] = other[_events.default[i]];
        }
      }

      if (!modalSettings.modalIsOpen) {
        return null;
      } else {
        var mobileOrientationIsPortrait =
        /* eslint-disable no-undef */
        DDC && DDC.mobile && DDC.mobile.orientation && DDC.mobile.orientation.currentOrientation && DDC.mobile.orientation.currentOrientation === 'portrait';
        /* eslint-enable */

        var currentModalIndex = modalSettings.persistIndex === false && !Number.isNaN(modalSettings.currentIndex) ? modalSettings.currentIndex : currentIndex;
        var showThumbnails = (mobileOrientationIsPortrait || isDesktop) && !modalSettings.videoIsOpen && !modalSettings.spin360IsOpen;
        var thumbnails = showThumbnails ? _react.default.createElement(_PhotoSwipeThumbnails.default, {
          images: images,
          currentIndex: currentModalIndex,
          goToPhoto: this.goToPhoto.bind(this),
          viewportWidth: viewportWidth,
          isDesktop: isDesktop,
          trackGa: trackGa
        }) : null;
        return _react.default.createElement(_common.Common, {
          render: function render(_ref) {
            var labels = _ref.labels;
            return _react.default.createElement("div", {
              className: "pswp-gallery-wrapper"
            }, _react.default.createElement("div", {
              className: "pswp-gallery"
            }, _react.default.createElement(_Photoswipe.default, _extends({}, eventProps, {
              isOpen: true,
              items: images.map(function (image) {
                return _objectSpread({}, image, {
                  h: 0,
                  w: 0,
                  resize: true,
                  type: 'image'
                });
              }),
              ref: function ref(pSwipeComp) {
                _this.pswpComponent = pSwipeComp;
              },
              options: {
                index: currentModalIndex,
                modal: true,
                loop: true,
                history: false,
                closeElClasses: ['item'],
                // desktop: close when black background is clicked outside of image
                tapToClose: !isDesktop,
                // mobile: tap anywhere to close the modal gallery
                clickToCloseNonZoomable: false,
                barsSize: {
                  top: 44,
                  bottom: 150
                },
                closeOnScroll: false,
                closeOnVerticalDrag: false
              },
              close: _this.handleClose.bind(_this),
              updateModalSettings: updateModalSettings,
              trackGa: trackGa,
              video: video,
              modalSettings: modalSettings,
              widgetInfo: widgetInfo,
              viewportWidth: viewportWidth,
              viewportHeight: viewportHeight,
              mobileOrientationIsPortrait: mobileOrientationIsPortrait || false,
              labels: labels
            })), thumbnails));
          }
        });
      }
    }
  }]);

  return PhotoSwipeGallery;
}(_react.default.Component);

PhotoSwipeGallery.propTypes = {
  currentIndex: _propTypes.default.number.isRequired,
  images: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    src: _propTypes.default.string,
    thumbnail: _propTypes.default.string
  })).isRequired,
  onClose: _propTypes.default.func,
  updateModalSettings: _propTypes.default.func.isRequired,
  trackGa: _propTypes.default.func.isRequired,
  modalSettings: _propTypes.default.shape({
    zoomedIn: _propTypes.default.bool,
    fullScreen: _propTypes.default.bool,
    modalIsOpen: _propTypes.default.bool,
    persistIndex: _propTypes.default.bool,
    currentIndex: _propTypes.default.number,
    videoIsOpen: _propTypes.default.bool,
    spin360IsOpen: _propTypes.default.bool
  }).isRequired,
  widgetInfo: _propTypes.default.shape({
    deviceType: _propTypes.default.string,
    accountId: _propTypes.default.string
  }).isRequired,
  viewportWidth: _propTypes.default.number.isRequired,
  viewportHeight: _propTypes.default.number.isRequired,
  video: _propTypes.default.shape({})
};
PhotoSwipeGallery.defaultProps = {
  onClose: function onClose() {},
  video: null
};
var _default = PhotoSwipeGallery;
exports.default = _default;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _PhotoSwipeGallery = _interopRequireDefault(__webpack_require__(28));

var _CommonLink = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PhotoSwipeGalleryButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PhotoSwipeGalleryButton, _React$Component);

  function PhotoSwipeGalleryButton(props) {
    var _this;

    _classCallCheck(this, PhotoSwipeGalleryButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PhotoSwipeGalleryButton).call(this, props));
    _this.state = {
      currentIndex: 0
    };
    return _this;
  }

  _createClass(PhotoSwipeGalleryButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          images = _this$props.images,
          modalSettings = _this$props.modalSettings,
          videos = _this$props.videos,
          videoOrder = _this$props.videoOrder,
          currentIndex = _this$props.currentIndex,
          innerWidth = _this$props.innerWidth,
          innerHeight = _this$props.innerHeight,
          widgetInfo = _this$props.widgetInfo,
          deviceType = _this$props.widgetInfo.deviceType,
          onCurrentIndexChange = _this$props.onCurrentIndexChange,
          updateModalSettings = _this$props.updateModalSettings,
          galleryBackgroundColor = _this$props.galleryBackgroundColor,
          galleryIconColor = _this$props.galleryIconColor,
          trackGa = _this$props.trackGa; // to fix an empty gallery showing up with 1 of 0 images

      var currentIndexPlusOne = images.length > 0 ? currentIndex + 1 : 0;
      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var labels = _ref.labels;
          return _react.default.createElement("div", null, _react.default.createElement("div", {
            className: "".concat(galleryBackgroundColor, " btn-border-radius-base p-3 d-flex align-items-center justify-content-center")
          }, _react.default.createElement(_CommonLink.default, {
            linkName: "".concat(currentIndexPlusOne, " ").concat(labels.get('OF'), " ").concat(images.length, " ").concat(labels.get('PHOTOS')),
            galleryIconColor: galleryIconColor,
            iconClass: "ddc-icon-images",
            onClick: function onClick() {
              updateModalSettings({
                modalIsOpen: true,
                videoIsOpen: false,
                spin360IsOpen: false
              });
              trackGa({
                element: 'Photo Count Button',
                elementCta: 'Photo Count',
                result: 'Opens gallery modal'
              });
            }
          }), videoOrder && videoOrder.length > 0 ? _react.default.createElement(_CommonLink.default, {
            linkName: labels.get('VIDEO'),
            galleryIconColor: galleryIconColor,
            iconClass: "ddc-icon-play2",
            onClick: function onClick() {
              updateModalSettings({
                modalIsOpen: true,
                videoIsOpen: true,
                spin360IsOpen: false
              });
              trackGa({
                element: 'Video Button',
                elementCta: 'Video',
                result: 'Opens video'
              });
            }
          }) : null, widgetInfo.vehicle.fyuseUid && widgetInfo.vehicle.fyuseUid.length > 0 ? _react.default.createElement(_common.Common, {
            render: function render(_ref2) {
              var flags = _ref2.flags;

              if (flags['ws-vehicle-media-homenet']) {
                return _react.default.createElement(_CommonLink.default, {
                  linkName: "360",
                  galleryIconColor: galleryIconColor,
                  iconClass: "ddc-icon-360-spin",
                  onClick: function onClick() {
                    updateModalSettings({
                      modalIsOpen: true,
                      videoIsOpen: false,
                      spin360IsOpen: true
                    });
                    trackGa({
                      element: 'Homenet 360 Button',
                      elementCta: 'Homenet',
                      result: 'Opens Homenet 360 spin'
                    });
                  }
                });
              } else {
                return null;
              }
            }
          }) : null), _react.default.createElement(_PhotoSwipeGallery.default, {
            isOpen: modalSettings.modalIsOpen,
            onClose: function onClose() {
              updateModalSettings({
                currentIndex: null,
                modalIsOpen: false,
                videoIsOpen: false,
                spin360IsOpen: false
              });
            },
            currentIndex: currentIndex,
            afterChange: function afterChange(gallery) {
              var pSwipe = gallery.photoSwipe;

              if (pSwipe && pSwipe.getCurrentIndex) {
                var index = pSwipe.getCurrentIndex();

                if (modalSettings.persistIndex) {
                  onCurrentIndexChange(index);
                }

                _this2.setState(function (prevState) {
                  // Need to track the index in local state because photoswipe uses this event
                  // mulitple times under the hood when it loads up or changes photos
                  if (prevState.currentIndex !== index && deviceType === 'MOBILE') {
                    trackGa({
                      element: 'Photo Carousel',
                      action: 'swiped',
                      result: "Move to ".concat(prevState.currentIndex < index ? 'Next' : 'Previous', " Photo"),
                      widgetState: 'Gallery Modal'
                    });
                  }

                  return {
                    currentIndex: index
                  };
                });

                updateModalSettings({
                  currentIndex: index
                });
              }
            },
            viewportWidth: Math.round(innerWidth),
            viewportHeight: Math.round(innerHeight),
            updateModalSettings: updateModalSettings,
            widgetInfo: widgetInfo,
            trackGa: trackGa,
            modalSettings: modalSettings,
            images: images,
            video: videoOrder.length > 0 ? videos[videoOrder[0]] : null // In the event there are multiple videos, take the first one
            ,
            labels: labels
          }));
        }
      });
    }
  }]);

  return PhotoSwipeGalleryButton;
}(_react.default.Component);

PhotoSwipeGalleryButton.propTypes = {
  onCurrentIndexChange: _propTypes.default.func.isRequired,
  images: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    src: _propTypes.default.string,
    thumbnail: _propTypes.default.string
  })).isRequired,
  videos: _propTypes.default.shape({}),
  videoOrder: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])).isRequired,
  modalSettings: _propTypes.default.shape({
    zoomedIn: _propTypes.default.bool,
    fullScreen: _propTypes.default.bool,
    modalIsOpen: _propTypes.default.bool,
    persistIndex: _propTypes.default.number
  }).isRequired,
  // renderSettings
  innerWidth: _propTypes.default.number.isRequired,
  innerHeight: _propTypes.default.number.isRequired,
  currentIndex: _propTypes.default.number.isRequired,
  updateModalSettings: _propTypes.default.func.isRequired,
  trackGa: _propTypes.default.func.isRequired,
  // prefs for colors
  galleryBackgroundColor: _propTypes.default.string,
  galleryIconColor: _propTypes.default.string,
  widgetInfo: _propTypes.default.shape({
    deviceType: _propTypes.default.string,
    vehicle: _propTypes.default.shape({
      fyuseUid: _propTypes.default.string
    }).isRequired
  }).isRequired
};
PhotoSwipeGalleryButton.defaultProps = {
  videos: null,
  galleryBackgroundColor: 'bg-white',
  galleryIconColor: 'text-primary'
};
var _default = PhotoSwipeGalleryButton;
exports.default = _default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _nukaCarousel = _interopRequireDefault(__webpack_require__(12));

var _reactBootstrap = __webpack_require__(4);

__webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PhotoSwipeThumbnails =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PhotoSwipeThumbnails, _React$Component);

  function PhotoSwipeThumbnails() {
    _classCallCheck(this, PhotoSwipeThumbnails);

    return _possibleConstructorReturn(this, _getPrototypeOf(PhotoSwipeThumbnails).apply(this, arguments));
  }

  _createClass(PhotoSwipeThumbnails, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.thumbnailSlider && nextProps.currentIndex !== this.props.currentIndex) {
        this.thumbnailSlider.goToSlide(this.getCurrentMiddleIndex(nextProps));
      }
    }
    /**
     * method uses the viewport and number of slides to display in order to have the currently viewed image centered
     * when there are enough images on either side,. or left or right aligned when its' towards the beginning or end of
     * the images array
     * @param props {optional} - viewportWidth, items, currentIndex. Uses this.props if not supplied.
     * @returns index that should be centered in the thumbnail display
     */

  }, {
    key: "getCurrentMiddleIndex",
    value: function getCurrentMiddleIndex(props) {
      var slidesToShow = this.getSlidesToShow(props);

      var _ref = props || this.props,
          images = _ref.images,
          currentIndex = _ref.currentIndex;

      var halfOfVisibleSlides = Math.round(slidesToShow / 2);
      var slideToBeCentered = currentIndex;

      if (slideToBeCentered < halfOfVisibleSlides) {
        var shouldStartSlidingIndex = halfOfVisibleSlides;

        if (slideToBeCentered < shouldStartSlidingIndex) {
          slideToBeCentered = shouldStartSlidingIndex;
        }
      } else {
        // -1 because we're looking for index, not length
        var shouldStopSlidingIndex = images.length - 1 - halfOfVisibleSlides;

        if (slideToBeCentered > shouldStopSlidingIndex) {
          slideToBeCentered = shouldStopSlidingIndex;
        }
      }

      return slideToBeCentered;
    }
  }, {
    key: "getSlidesToShow",
    value: function getSlidesToShow(props) {
      var _ref2 = props || this.props,
          viewportWidth = _ref2.viewportWidth; // 244 gap leaves a 2 slide positioning difference.


      return parseInt((viewportWidth - 244) / 114, 10);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var decorators = [];
      var slidesToShow = this.getSlidesToShow();
      var _this$props = this.props,
          currentIndex = _this$props.currentIndex,
          images = _this$props.images,
          isDesktop = _this$props.isDesktop,
          viewportWidth = _this$props.viewportWidth,
          trackGa = _this$props.trackGa,
          goToPhoto = _this$props.goToPhoto; // plus 1 so we only care when we have a slide off screen

      var halfOfSlidesToShow = parseInt(slidesToShow / 2, 10) + 1;

      if (currentIndex > halfOfSlidesToShow) {
        decorators.push({
          component: function component() {
            return _react.default.createElement("div", {
              type: "previous",
              className: "fader fade-right"
            });
          },
          position: 'CenterLeft'
        });
      } // - 1 to adjust for length vs index


      if (currentIndex < images.length - 1 - halfOfSlidesToShow) {
        decorators.push({
          component: function component() {
            return _react.default.createElement("div", {
              type: "next",
              className: "fader fade-left"
            });
          },
          position: 'CenterRight'
        });
      }

      var sliderProps = {
        decorators: decorators,
        cellSpacing: 4,
        swiping: !isDesktop,
        dragging: false,
        cellAlign: 'center',
        wrapAround: false,
        speed: 250,
        slidesToShow: this.getSlidesToShow(),
        slideIndex: this.getCurrentMiddleIndex(),
        width: "".concat(viewportWidth, "px"),
        slideWidth: '114px',
        ref: function ref(cmp) {
          _this.thumbnailSlider = cmp;
        }
      };
      return _react.default.createElement("div", {
        className: "pswp-thumbnails fixed-bottom pt-2 pb-2 bg-black"
      }, _react.default.createElement(_nukaCarousel.default, sliderProps, images.map(function (image) {
        return _react.default.createElement(_reactBootstrap.Image, {
          alt: "",
          key: "pswp-thumb-".concat(image.id),
          className: "pswp-thumbnail ws-vehicle-media-thumbnail ".concat(image.id === _this.props.currentIndex ? 'active' : ''),
          src: image.thumbnail,
          width: 106,
          height: 80,
          onClick: function onClick(e) {
            goToPhoto(image.id, e);
            trackGa({
              element: 'Thumbnail Carousel',
              result: 'Photo comes into view',
              widgetState: 'Gallery Modal'
            });
          },
          onLoad: function onLoad() {
            // Fire a resize event to force a redraw of the carousel so it can recalculate the height
            if (image.id === 0) {
              window.dispatchEvent(new Event('resize'));
            }
          }
        });
      })));
    }
  }]);

  return PhotoSwipeThumbnails;
}(_react.default.Component);

PhotoSwipeThumbnails.propTypes = {
  currentIndex: _propTypes.default.number.isRequired,
  images: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    src: _propTypes.default.string,
    thumbnail: _propTypes.default.string
  })).isRequired,
  trackGa: _propTypes.default.func.isRequired,
  goToPhoto: _propTypes.default.func.isRequired,
  viewportWidth: _propTypes.default.number.isRequired,
  isDesktop: _propTypes.default.bool.isRequired
};
var _default = PhotoSwipeThumbnails;
exports.default = _default;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(2);

var _events = _interopRequireDefault(__webpack_require__(8));

__webpack_require__(58);

var _CommonButton = _interopRequireDefault(__webpack_require__(26));

var _DDCPlayerVideoComponent = _interopRequireDefault(__webpack_require__(20));

var _IFrameVideoComponent = _interopRequireDefault(__webpack_require__(21));

var _Homenet360Component = _interopRequireDefault(__webpack_require__(25));

var _Arrow = _interopRequireDefault(__webpack_require__(6));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var pauseVideo = function pauseVideo() {
  DDC.Video.getAllPlayers().forEach(function (player) {
    if (player.getState() === 'PLAYING') {
      player.pause();
    }
  });
};

var Photoswipe =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Photoswipe, _React$Component);

  function Photoswipe() {
    _classCallCheck(this, Photoswipe);

    return _possibleConstructorReturn(this, _getPrototypeOf(Photoswipe).apply(this, arguments));
  }

  _createClass(Photoswipe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var modalIsOpen = this.props.modalSettings.modalIsOpen;

      if (modalIsOpen) {
        this.openPhotoSwipe(this.props);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var modalIsOpen = nextProps.modalSettings.modalIsOpen;

      if (!modalIsOpen) {
        this.openPhotoSwipe(nextProps);
      } else {
        var items = this.props.items;
        var newItems = nextProps.items;
        var hasChanges = false;

        if (items.length !== newItems.length) {
          hasChanges = true;
        }

        items.forEach(function (item, index) {
          if (newItems[index]) {
            if (newItems[index].id !== item.id || newItems[index].src !== item.src) {
              hasChanges = true;
            }
          }
        });

        if (hasChanges) {
          this.updateItems(newItems);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.closePhotoSwipe();
    }
  }, {
    key: "openPhotoSwipe",
    value: function openPhotoSwipe(props) {
      var _this = this;

      var items = props.items,
          options = props.options;
      var pswpElement = this.pswpElement;
      /* eslint no-undef: 0 */

      this.photoSwipe = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

      _events.default.forEach(function (event) {
        var callback = props[event];

        if (callback || event === 'destroy') {
          var self = _this;

          _this.photoSwipe.listen(event, function () {
            if (callback) {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              args.unshift(_this);
              callback.apply(void 0, args);
            }

            if (event === 'destroy') {
              self.handleClose();
            }
          });
        }
      });

      this.photoSwipe.listen('imageLoadComplete', function (index, item) {
        if (!item.resize) return;
        var img = new Image();
        img.src = item.src;
        /* eslint-disable no-param-reassign */

        img.onload = function () {
          item.w = img.naturalWidth;
          item.h = img.naturalHeight;
          item.resize = false;

          _this.photoSwipe.invalidateCurrItems();

          _this.photoSwipe.updateSize(true);
        };
      });
      this.photoSwipe.init();
    }
  }, {
    key: "updateItems",
    value: function updateItems() {
      var _this2 = this;

      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.photoSwipe.items.length = 0;
      items.forEach(function (item) {
        _this2.photoSwipe.items.push(item);
      });
      this.photoSwipe.invalidateCurrItems();
      this.photoSwipe.updateSize(true);
    }
  }, {
    key: "closePhotoSwipe",
    value: function closePhotoSwipe() {
      if (!this.photoSwipe) {
        return;
      }

      this.photoSwipe.close();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this$props = this.props,
          onClose = _this$props.onClose,
          updateModalSettings = _this$props.updateModalSettings,
          trackGa = _this$props.trackGa;
      updateModalSettings({
        modalIsOpen: false
      });

      if (onClose) {
        onClose();
        trackGa({
          element: 'Modal Gallery Close Button',
          result: 'Closes gallery modal',
          widgetState: 'Gallery Modal'
        });
      }
    }
  }, {
    key: "trackZoomEvent",
    value: function trackZoomEvent() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var trackGa = this.props.trackGa;
      var zoomed = this.photoSwipe.getZoomLevel() >= 1;
      var element = el;

      if (!el) {
        element = zoomed ? 'Zoom out Button' : 'Zoom in Button';
      }

      trackGa({
        element: element,
        result: zoomed ? 'Zooms out of photo' : 'Zooms into photo',
        widgetState: 'Gallery Modal'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          updateModalSettings = _this$props2.updateModalSettings,
          trackGa = _this$props2.trackGa,
          modalSettings = _this$props2.modalSettings,
          video = _this$props2.video,
          widgetInfo = _this$props2.widgetInfo,
          viewportWidth = _this$props2.viewportWidth,
          viewportHeight = _this$props2.viewportHeight,
          mobileOrientationIsPortrait = _this$props2.mobileOrientationIsPortrait,
          labels = _this$props2.labels;
      var fullScreen = modalSettings.fullScreen,
          videoIsOpen = modalSettings.videoIsOpen,
          spin360IsOpen = modalSettings.spin360IsOpen;
      var deviceType = widgetInfo.deviceType;
      var showGallery = videoIsOpen || spin360IsOpen;
      var show360Spin = widgetInfo.vehicle && widgetInfo.vehicle.fyuseUid && widgetInfo.vehicle.fyuseUid.length > 0;
      var videoComponent;

      if (video && video.provider && video.provider === 'DCPAIS') {
        videoComponent = _react.default.createElement(_IFrameVideoComponent.default, {
          video: video,
          modalSettings: modalSettings,
          widgetInfo: widgetInfo,
          viewportWidth: viewportWidth,
          viewportHeight: viewportHeight,
          mobileOrientationIsPortrait: mobileOrientationIsPortrait
        });
      } else {
        videoComponent = _react.default.createElement(_DDCPlayerVideoComponent.default, {
          video: video,
          modalSettings: modalSettings,
          widgetInfo: widgetInfo,
          viewportWidth: viewportWidth,
          viewportHeight: viewportHeight,
          mobileOrientationIsPortrait: mobileOrientationIsPortrait
        });
      }

      return _react.default.createElement("div", {
        className: ['pswp', className].join(' '),
        tabIndex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        ref: function ref(node) {
          _this3.pswpElement = node;
        }
      }, _react.default.createElement("div", {
        className: "media-buttons-toolbar fixed-top w-75 text-left pt-1"
      }, _react.default.createElement(_CommonButton.default, {
        buttonName: labels.get('PHOTOS'),
        bsSize: deviceType === 'DESKTOP' ? 'small' : null,
        iconClass: "ddc-icon-images",
        buttonClasses: deviceType !== 'DESKTOP' ? 'text-nowrap' : '',
        onClick: function onClick() {
          updateModalSettings({
            videoIsOpen: false,
            spin360IsOpen: false
          });
          pauseVideo();
          trackGa({
            element: 'Photo Count Button',
            elementCta: 'Photo Count',
            result: 'Opens photos',
            widgetState: 'Gallery Modal'
          });
        }
      }), video != null ? _react.default.createElement(_CommonButton.default, {
        buttonName: labels.get('VIDEO'),
        bsSize: deviceType === 'DESKTOP' ? 'small' : null,
        iconClass: "ddc-icon-play2",
        buttonClasses: deviceType !== 'DESKTOP' ? 'text-nowrap' : '',
        onClick: function onClick() {
          updateModalSettings({
            videoIsOpen: true,
            spin360IsOpen: false
          });
          trackGa({
            element: 'Video Button',
            elementCta: 'Video',
            result: 'Opens video',
            widgetState: 'Gallery Modal'
          });
        }
      }) : null, show360Spin ? _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var flags = _ref.flags;

          if (flags['ws-vehicle-media-homenet']) {
            return _react.default.createElement(_CommonButton.default, {
              buttonName: "360",
              bsSize: deviceType === 'DESKTOP' ? 'small' : null,
              iconClass: "ddc-icon-360-spin",
              buttonClasses: deviceType !== 'DESKTOP' ? 'text-nowrap' : '',
              onClick: function onClick() {
                updateModalSettings({
                  videoIsOpen: false,
                  spin360IsOpen: true
                });
                pauseVideo();
                trackGa({
                  element: 'Homenet 360 Button',
                  elementCta: 'Homenet',
                  result: 'Opens Homenet 360 spin',
                  widgetState: 'Gallery Modal'
                });
              }
            });
          } else {
            return null;
          }
        }
      }) : null), _react.default.createElement("div", {
        className: "pswp__bg"
      }), _react.default.createElement("div", {
        className: "pswp__scroll-wrap"
      }, _react.default.createElement("div", {
        className: "pswp__container ".concat(showGallery ? 'hide' : null),
        onClick: function onClick() {
          return _this3.trackZoomEvent('Photo Carousel');
        },
        role: "button",
        tabIndex: "-1",
        onKeyDown: function onKeyDown() {// TODO: figure out what to do here because of jsx-a11y/click-events-have-key-events
        }
      }, _react.default.createElement("div", {
        className: "pswp__item"
      }), _react.default.createElement("div", {
        className: "pswp__item"
      }), _react.default.createElement("div", {
        className: "pswp__item"
      })), _react.default.createElement("div", {
        className: "pswp__ui pswp__ui--hidden"
      }, _react.default.createElement("div", {
        className: "pswp__top-bar"
      }, _react.default.createElement("button", {
        className: "pswp__button pswp__button--close",
        title: "".concat(labels.get('CLOSE'), " (Esc)")
      }), _react.default.createElement("button", {
        className: "pswp__button pswp__button--fs",
        title: labels.get('TOGGLE_FULLSCREEN'),
        onClick: function onClick() {
          var fullscreenMode = fullScreen ? !fullScreen : true;
          updateModalSettings({
            fullScreen: fullscreenMode
          });
          trackGa({
            element: 'Fullscreen button',
            result: !fullscreenMode ? 'Exits fullscreen mode' : 'Enters fullscreen mode',
            widgetState: 'Gallery Modal'
          });
        }
      }), _react.default.createElement("button", {
        className: "pswp__button pswp__button--zoom ".concat(showGallery ? 'hidden' : null),
        title: labels.get('ZOOM_IN_OUT'),
        onClick: function onClick() {
          return _this3.trackZoomEvent();
        }
      }), _react.default.createElement("div", {
        className: "pswp__preloader"
      }, _react.default.createElement("div", {
        className: "pswp__preloader__icn"
      }, _react.default.createElement("div", {
        className: "pswp__preloader__cut"
      }, _react.default.createElement("div", {
        className: "pswp__preloader__donut"
      }))))), _react.default.createElement(_Arrow.default, {
        direction: "left",
        onClickEvent: function onClickEvent() {
          trackGa({
            element: 'Modal Gallery Previous Button',
            result: 'Move to previous photo',
            widgetState: 'Gallery Modal'
          });
        },
        classes: ['pswp__button', 'pswp__button--arrow--left', "".concat(showGallery ? 'hidden' : ''), "".concat(deviceType === 'DESKTOP' ? 'visible' : '')]
      }), _react.default.createElement(_Arrow.default, {
        direction: "right",
        onClickEvent: function onClickEvent() {
          trackGa({
            element: 'Modal Gallery Next Button',
            result: 'Move to next photo',
            widgetState: 'Gallery Modal'
          });
        },
        classes: ['pswp__button', 'pswp__button--arrow--right', "".concat(showGallery ? 'hidden' : ''), "".concat(deviceType === 'DESKTOP' ? 'visible' : '')]
      }), _react.default.createElement("div", {
        className: "pswp__caption"
      }, _react.default.createElement("div", {
        className: "pswp__caption__center"
      })), _react.default.createElement("div", {
        className: "pswp__counter text-center fixed-bottom bg-black ".concat(showGallery ? 'hidden' : '')
      }))), videoComponent, show360Spin ? _react.default.createElement(_Homenet360Component.default, {
        modalSettings: modalSettings,
        fyuseUid: widgetInfo.vehicle.fyuseUid,
        trackGa: trackGa
      }) : null);
    }
  }]);

  return Photoswipe;
}(_react.default.Component);

Photoswipe.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    src: _propTypes.default.string
  })).isRequired,

  /* eslint react/no-unused-prop-types: 0 */
  options: _propTypes.default.shape({}),
  onClose: _propTypes.default.func,
  className: _propTypes.default.string,
  updateModalSettings: _propTypes.default.func.isRequired,
  trackGa: _propTypes.default.func.isRequired,
  modalSettings: _propTypes.default.shape({
    zoomedIn: _propTypes.default.bool,
    modalIsOpen: _propTypes.default.bool,
    fullScreen: _propTypes.default.bool,
    videoIsOpen: _propTypes.default.bool,
    spin360IsOpen: _propTypes.default.bool
  }).isRequired,
  widgetInfo: _propTypes.default.shape({
    deviceType: _propTypes.default.string,
    vehicle: _propTypes.default.shape({
      fyuseUid: _propTypes.default.string
    }).isRequired
  }).isRequired,
  viewportWidth: _propTypes.default.number.isRequired,
  viewportHeight: _propTypes.default.number.isRequired,
  video: _propTypes.default.shape({
    provider: _propTypes.default.string
  }),
  mobileOrientationIsPortrait: _propTypes.default.bool.isRequired,
  labels: _propTypes.default.shape({
    get: _propTypes.default.func
  }).isRequired
};
Photoswipe.defaultProps = {
  options: {},
  onClose: function onClose() {},
  className: '',
  video: null
};
var _default = Photoswipe;
exports.default = _default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = __webpack_require__(14);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _modalSettings = __webpack_require__(16);

var _renderSettings = __webpack_require__(18);

var _myCars = __webpack_require__(17);

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(22));

var _Slider = _interopRequireDefault(__webpack_require__(24));

var _PhotoSwipeGalleryButton = _interopRequireDefault(__webpack_require__(29));

var _SingleImage = _interopRequireDefault(__webpack_require__(23));

var _Cta = _interopRequireDefault(__webpack_require__(19));

var _MyCarsButton = _interopRequireDefault(__webpack_require__(7));

var _mycars = __webpack_require__(34);

var _viewportSize2 = _interopRequireDefault(__webpack_require__(35));

var _utility = __webpack_require__(9);

__webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer(props) {
    var _this;

    _classCallCheck(this, WidgetContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).call(this, props));
    _this.onResize = _this.onResize.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.trackGa = _this.trackGa.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var deviceType = this.props.widgetInfo.deviceType;
      this.setRenderSettings();
      this.props.updateModalSettings({
        modalIsOpen: false
      });
      var enableMyCars = this.props.updateMyCarsEnabled.bind(this, true);
      var updateVehicles = this.props.updateMyCarsSavedVehicles.bind(this);
      /* eslint ignore no-undef:0 */

      $.subscribe('userProfile-loaded', function () {
        // profile is guaranteed to be there after profile loads
        enableMyCars();
        (0, _mycars.getVehiclesForProfile)($, DDC.userProfile.profileId, updateVehicles);
      });
      /* eslint ignore no-undef:0 */

      $(document).on('ajaxSuccess', function (event, data, settings) {
        var url = settings.url;

        if (url.indexOf('/apis/mycars/') > -1 && url.indexOf('fromMedia=true') === -1) {
          // userProfileId cookie is used if not a real profile ie. anonymous saving
          var profileId = DDC.userProfile.profileId || $.cookie('userProfileId');

          if (profileId) {
            enableMyCars();
            (0, _mycars.getVehiclesForProfile)($, profileId, updateVehicles);
          }
        }
      });

      if (!this.debouncedResize) {
        /* eslint no-undef: 0 */
        this.debouncedResize = (0, _utility.debounce)(this.onResize, deviceType === 'MOBILE' ? 250 : 100);
      }

      window.addEventListener('resize', this.debouncedResize, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedResize, false);
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.setRenderSettings();
    }
  }, {
    key: "setRenderSettings",
    value: function setRenderSettings() {
      var _this$props = this.props,
          prefs = _this$props.prefs,
          renderSettings = _this$props.renderSettings,
          deviceType = _this$props.widgetInfo.deviceType,
          media = _this$props.media;

      var _viewportSize = (0, _viewportSize2.default)(),
          viewportWidth = _viewportSize.viewportWidth,
          viewportHeight = _viewportSize.viewportHeight;

      var innerWidth = viewportWidth;
      var innerHeight = viewportHeight; // Widget preferences

      var threeUpRatio = parseFloat(prefs.threeUpRatio) || 1;
      var responsiveDesktopImage = prefs.responsiveDesktopImage !== 'false';
      var isMobile = deviceType === 'MOBILE';
      var responsiveImage = isMobile || responsiveDesktopImage;
      var aspectRatio = innerWidth / innerHeight;
      var numSlides = media.images.length;
      var threeUpDisplay = aspectRatio > threeUpRatio && numSlides > 1; // If page is taller than wide show 1

      var imageMode = !responsiveImage || threeUpDisplay || isMobile; // Always use <Image> elements on mobile
      // Get previous state

      var _renderSettings$curre = renderSettings.currentIndex,
          currentIndex = _renderSettings$curre === void 0 ? 0 : _renderSettings$curre; // If we've got no overflow on a 3-up display

      if (threeUpDisplay && numSlides <= 3) {
        // Reset slides to beginning to show all in 3-up
        currentIndex = 0; // Don't allow the gallery to change the slide index

        this.props.updateModalSettings({
          persistIndex: false
        });
      } else {
        // Allow the current gallery slide to be shown first when returning to vehicle page
        this.props.updateModalSettings({
          persistIndex: true
        });
      }

      this.props.updateRenderSettings({
        innerWidth: innerWidth,
        innerHeight: innerHeight,
        threeUpDisplay: threeUpDisplay,
        imageMode: imageMode,
        responsiveImage: responsiveImage,
        currentIndex: currentIndex
      });

      if (isMobile && this.sliderCmp) {
        // make sure mobile properly resizes its slider container on dimension change
        this.sliderCmp.refs.slider.setDimensions();
      }
    }
  }, {
    key: "trackGa",
    value: function trackGa(trackingObj) {
      var DDC = window.DDC || {};
      var defaultTrackingObj = {
        event: 'widgetUserEvent',
        widgetName: 'ws-vehicle-media',
        widgetId: this.props.widgetInfo.windowId,
        widgetState: "default (".concat(this.props.renderSettings.threeUpDisplay ? 'tile view' : 'full view', ")"),
        element: '',
        action: 'clicked',
        result: '',
        elementCta: null
      };

      if (DDC.fireTrackingEvent) {
        DDC.fireTrackingEvent(_objectSpread({}, defaultTrackingObj, trackingObj));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$media = _this$props2.media,
          images = _this$props2$media.images,
          videos = _this$props2$media.videos,
          videoOrder = _this$props2$media.videoOrder,
          widgetInfo = _this$props2.widgetInfo,
          _this$props2$widgetIn = _this$props2.widgetInfo,
          deviceType = _this$props2$widgetIn.deviceType,
          pathParameters = _this$props2$widgetIn.pathParameters,
          siteId = _this$props2$widgetIn.accountId,
          vehicle = _this$props2$widgetIn.vehicle,
          _this$props2$prefs = _this$props2.prefs,
          galleryBackgroundColor = _this$props2$prefs.galleryBackgroundColor,
          galleryIconColor = _this$props2$prefs.galleryIconColor,
          ctaHref1 = _this$props2$prefs.ctaHref1,
          ctaLabel1 = _this$props2$prefs.ctaLabel1,
          ctaIsVehicleLink1 = _this$props2$prefs.ctaIsVehicleLink1,
          ctaIsDialogLink1 = _this$props2$prefs.ctaIsDialogLink1,
          ctaDialogTitle1 = _this$props2$prefs.ctaDialogTitle1,
          ctaDialogWidth1 = _this$props2$prefs.ctaDialogWidth1,
          offsetSharedVehicleImageByOne = _this$props2$prefs.offsetSharedVehicleImageByOne,
          useStockPhotosForOffsiteInventory = _this$props2$prefs.useStockPhotosForOffsiteInventory,
          galleryToolbarPlacement = _this$props2$prefs.galleryToolbarPlacement,
          updateRenderSettings = _this$props2.updateRenderSettings,
          updateModalSettings = _this$props2.updateModalSettings,
          _this$props2$renderSe = _this$props2.renderSettings,
          innerHeight = _this$props2$renderSe.innerHeight,
          innerWidth = _this$props2$renderSe.innerWidth,
          imageMode = _this$props2$renderSe.imageMode,
          responsiveImage = _this$props2$renderSe.responsiveImage,
          threeUpDisplay = _this$props2$renderSe.threeUpDisplay,
          currentIndex = _this$props2$renderSe.currentIndex,
          modalSettings = _this$props2.modalSettings;
      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var sitemap = _ref.sitemap;

          // If renderSettings and innerWidth are not set,
          // we can assume that window is not yet in context
          // indicating the widget has not fully initialized
          if (!innerWidth) {
            return _react.default.createElement(_LoadingSpinner.default, null);
          } // If a vehicle's accountId does not match the widget's siteId,
          // we can assume this is a shared vehicle, and thus should not
          // include the first image as props, bc it often features
          // an overlay featuring the wrong dealership


          var imagesToDisplay = _toConsumableArray(images);

          var hasImages = true;
          var firstImageIndex = images.findIndex(function (image) {
            return image.id === 0;
          });

          if (siteId !== vehicle.accountId && offsetSharedVehicleImageByOne === 'true' && // if showing only stock photos don't offset
          useStockPhotosForOffsiteInventory !== 'true') {
            if (imagesToDisplay.length === 1) {
              // TODO - set first image source to no images image
              hasImages = false;
              imagesToDisplay[0].src = "https://".concat(window.location.host, "/v9/media/images/widget-images/v1/no-photo-lrg.png");
              imagesToDisplay[0].thumbnail = imagesToDisplay[0].src;
            } else {
              imagesToDisplay.splice(firstImageIndex, 1); // if the first gets spliced out, ids will start at 1, so this fixes that

              if (imagesToDisplay[firstImageIndex].id === 1) {
                imagesToDisplay = imagesToDisplay.map(function (img) {
                  var newImg = {
                    id: img.id - 1,
                    // shift every id back 1
                    src: img.src,
                    thumbnail: img.thumbnail
                  };
                  return newImg;
                });
              }
            }
          }

          var galleryProps = {
            images: imagesToDisplay,
            widgetInfo: widgetInfo,
            modalSettings: modalSettings,
            videos: videos,
            videoOrder: videoOrder,
            // renderSettings,
            currentIndex: currentIndex,
            innerHeight: innerHeight,
            innerWidth: innerWidth,
            imageMode: imageMode,
            responsiveImage: responsiveImage,
            threeUpDisplay: threeUpDisplay,
            updateRenderSettings: updateRenderSettings,
            updateModalSettings: updateModalSettings,
            // Prefs for PhotoSwipe
            galleryBackgroundColor: galleryBackgroundColor,
            galleryIconColor: galleryIconColor,
            onCurrentIndexChange: function onCurrentIndexChange(newIndex, cb) {
              if (newIndex !== _this2.props.renderSettings.currentIndex) {
                updateRenderSettings({
                  currentIndex: newIndex
                });
              }

              if (cb) {
                cb(newIndex);
              }
            },
            onPhotoClick: hasImages ? function () {
              var clickedIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props.renderSettings.currentIndex;

              _this2.trackGa({
                element: 'Photo Carousel',
                result: 'Opens gallery modal'
              });

              updateModalSettings({
                modalIsOpen: true,
                videoIsOpen: false,
                spin360IsOpen: false,
                currentIndex: clickedIndex
              });
              updateRenderSettings({
                currentIndex: clickedIndex
              });
            } : function () {},
            trackGa: _this2.trackGa
          };

          var slider = _react.default.createElement(_Slider.default, _extends({
            ref: function ref(sc) {
              _this2.sliderCmp = sc;
            }
          }, galleryProps));

          var photoSwipeGalleryButton = _react.default.createElement(_PhotoSwipeGalleryButton.default, galleryProps);

          var mycarsButton = _this2.props.myCars.enabled ? _react.default.createElement(_MyCarsButton.default, {
            uuid: pathParameters.vehicleId,
            transparent: deviceType === 'MOBILE',
            trackGa: _this2.trackGa,
            myCars: _this2.props.myCars,
            key: "MyCarsButtonComponent"
          }) : null;
          var iconSize = '24';

          var ctaIconSvg1 = _react.default.createElement("svg", {
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            width: iconSize,
            height: iconSize,
            viewBox: "0 0 24 24",
            className: "ddc-icon-vehicle-media-cta"
          }, _react.default.createElement("path", {
            d: "M14.5,9.8c-6,0-11.1,3.9-12.5,9.6l0,0c3.3-3.3,8-5,12.5-5l0,0v5L22,12l-7.5-7.5V9.8z"
          }));

          var params = new Map();

          if (ctaIsVehicleLink1 === 'true') {
            params.set('itemId', pathParameters.vehicleId);
          }

          var cta1 = _react.default.createElement(_Cta.default, {
            href: sitemap.get(ctaHref1),
            icon: ctaIconSvg1,
            label: ctaLabel1,
            params: params,
            dialog: ctaIsDialogLink1 === 'true',
            dialogTitle: ctaDialogTitle1,
            dialogWidth: ctaDialogWidth1,
            transparent: deviceType === 'MOBILE',
            trackGa: _this2.trackGa,
            key: "CTA1"
          });

          var ctaList = [cta1, mycarsButton];
          var ctaContainerClasses = ['cta-container', 'd-flex', 'd-print-none', 'position-absolute'];

          if (deviceType !== 'MOBILE') {
            ctaContainerClasses.push('my-4');
          }

          var ctas = ctaList.join('').length ? _react.default.createElement("div", {
            className: ctaContainerClasses.join(' ')
          }, ctaList) : null; // If the image has been removed as a result of offsetSharedVehicleImageByOne
          // make sure to grab the correct first image, and grab by id in case of
          // random ordering, though we haven't observed that

          var firstImage = imagesToDisplay.find(function (image) {
            return image.id === 0;
          });
          var firstImageSrc = '';

          if (firstImage) {
            firstImageSrc = firstImage.src;
          }

          var singleImage = deviceType === 'DESKTOP' ? _react.default.createElement(_SingleImage.default, {
            image: firstImageSrc,
            uuid: pathParameters.vehicleId,
            onClick: function onClick() {
              _this2.trackGa({
                element: 'Photo',
                result: 'Opens gallery modal',
                widgetState: 'default (thumbnail)'
              });

              updateModalSettings({
                modalIsOpen: true,
                videoIsOpen: false,
                spin360IsOpen: false,
                currentIndex: 0
              });
            },
            trackGa: _this2.trackGa,
            myCars: _this2.props.myCars
          }) : null; // The data-location attribute is used by the Third Party API
          // as a consistent named location for third parties to inject
          // content of a particular type. More information is available at:
          // https://ghe.coxautoinc.com/DDC-WebPlatform/ddc-js-api

          var mediaContent = _react.default.createElement("div", {
            className: "media-content",
            "data-location": "vehicle-media-container"
          }, _react.default.createElement("div", {
            className: "media-gallery-toolbar mobile-toolbar w-100 text-center py-1 d-print-none"
          }, photoSwipeGalleryButton), ctas, slider, singleImage);

          if (widgetInfo.deviceType === 'DESKTOP') {
            mediaContent = _react.default.createElement("div", {
              className: "media-content",
              "data-location": "vehicle-media-container"
            }, ctas, slider, singleImage, _react.default.createElement("div", {
              className: "media-gallery-toolbar border m-4 ".concat(galleryToolbarPlacement === 'top-left' ? 'absolute-top' : 'absolute-bottom', " absolute-left d-print-none")
            }, photoSwipeGalleryButton));
          }

          return mediaContent;
        }
      });
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

WidgetContainer.propTypes = {
  prefs: _propTypes.default.shape({
    threeUpRatio: _propTypes.default.string,
    responsiveDesktopImage: _propTypes.default.string,
    galleryBackgroundColor: _propTypes.default.string,
    galleryIconColor: _propTypes.default.string,
    ctaHref1: _propTypes.default.string,
    ctaLabel1: _propTypes.default.string,
    ctaIsVehicleLink1: _propTypes.default.string,
    ctaIsDialogLink1: _propTypes.default.string,
    ctaDialogTitle1: _propTypes.default.string,
    ctaDialogWidth1: _propTypes.default.string,
    offsetSharedVehicleImageByOne: _propTypes.default.string,
    galleryToolbarPlacement: _propTypes.default.string,
    useStockPhotosForOffsiteInventory: _propTypes.default.string
  }),
  media: _propTypes.default.shape({
    images: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.number,
      src: _propTypes.default.string,
      thumbnail: _propTypes.default.string
    })).isRequired,
    videos: _propTypes.default.shape({}),
    videoOrder: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))
  }).isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string,
    vehicle: _propTypes.default.shape({
      accountId: _propTypes.default.string
    }).isRequired,
    accountId: _propTypes.default.string,
    pathParameters: _propTypes.default.shape({
      vehicleId: _propTypes.default.string
    }).isRequired
  }).isRequired,
  renderSettings: _propTypes.default.shape({
    innerHeight: _propTypes.default.number,
    innerWidth: _propTypes.default.number,
    imageMode: _propTypes.default.bool,
    responsiveImage: _propTypes.default.bool,
    threeUpDisplay: _propTypes.default.bool,
    currentIndex: _propTypes.default.number
  }),
  modalSettings: _propTypes.default.shape({
    modalIsOpen: _propTypes.default.bool
  }),
  updateRenderSettings: _propTypes.default.func.isRequired,
  updateModalSettings: _propTypes.default.func.isRequired,
  myCars: _propTypes.default.shape({
    enabled: _propTypes.default.bool.isRequired,
    savedVehicles: _propTypes.default.arrayOf(_propTypes.default.shape({
      itemUUID: _propTypes.default.string
    }))
  }),
  updateMyCarsEnabled: _propTypes.default.func.isRequired,
  updateMyCarsSavedVehicles: _propTypes.default.func.isRequired
};
WidgetContainer.defaultProps = {
  prefs: {
    threeUpRatio: '1',
    responsiveDesktopImage: 'true',
    offsetSharedVehicleImageByOne: 'false',
    galleryToolbarPlacement: 'bottom-left'
  },
  renderSettings: {
    innerHeight: null,
    innerWidth: null,
    imageMode: false,
    responsiveImage: true,
    threeUpDisplay: false,
    currentIndex: 0
  },
  modalSettings: {
    modalIsOpen: false
  },
  myCars: {
    enabled: false,
    savedVehicles: null
  }
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    prefs: state.prefs,
    media: state.media,
    widgetInfo: state.widgetInfo,
    renderSettings: state.renderSettings,
    modalSettings: state.modalSettings,
    myCars: state.myCars
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateRenderSettings: function updateRenderSettings(props) {
      dispatch((0, _renderSettings.setRenderSettings)(props));
    },
    updateModalSettings: function updateModalSettings(props) {
      dispatch((0, _modalSettings.setModalSettings)(props));
    },
    updateMyCarsSavedVehicles: function updateMyCarsSavedVehicles(props) {
      dispatch((0, _myCars.setMyCarsSavedVehicles)(props));
    },
    updateMyCarsEnabled: function updateMyCarsEnabled(enabled) {
      dispatch((0, _myCars.setMyCarsEnabled)(enabled));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);

exports.default = _default;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageResizer;

function imageResizer(threeUpDisplay, width, uri) {
  var threeUpRatio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var resizeWidth; // Divide the width by 3 when the carousel is displaying 3 images

  var imageWidth = threeUpDisplay ? width / 3 * threeUpRatio : width; // Set breakpoints so that we're only caching a limited # of image sizes

  switch (true) {
    case imageWidth <= 320:
      resizeWidth = 320; // iPhone 5

      break;

    case imageWidth <= 414:
      resizeWidth = 414; // iPhone 6/7/8 Plus

      break;

    case imageWidth <= 768:
      resizeWidth = 768; // iPad

      break;

    default:
      resizeWidth = 1024;
  } // 2nd condition needed to pass the test


  return uri.includes('dealer.com') ? "".concat(uri, "?impolicy=resize&w=").concat(resizeWidth) : uri;
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVehiclesForProfile = void 0;

/**
 *
 * @param $ - jquery object for making $.ajax call
 * @param profileId - profileId for user to pull vehicles for
 * @param callback - method is called with an array of the saved vehicles for the given user as it's only param
 */
var getVehiclesForProfile = function getVehiclesForProfile($, profileId, callback) {
  $.ajax({
    type: 'GET',
    url: "/apis/mycars/v1/profiles/".concat(profileId, "/vehicles"),
    cache: false,
    data: {
      // fromMedia: hack use this param to signal that we don't need to monitor this ajax request
      // otherwise gets stuck in infinite loop listening to it's own calls
      fromMedia: true,
      statusType: 'SAVED'
    },
    contentType: 'application/json',
    success: function success(data) {
      callback(data.results);
    },
    error: function error() {
      callback([]);
    }
  });
};

exports.getVehiclesForProfile = getVehiclesForProfile;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = viewportSize;

/*!
 An experiment in getting accurate visible viewport dimensions across devices
 (c) 2012 Scott Jehl. 
 MIT/GPLv2 Licence
*/
function viewportSize() {
  var testElement = document.createElement('div');
  testElement.style.cssText = 'position: fixed;top: 0;left: 0;bottom: 0;right: 0;';
  document.documentElement.insertBefore(testElement, document.documentElement.firstChild);
  var dimensions = {
    viewportWidth: testElement.offsetWidth,
    viewportHeight: testElement.offsetHeight
  };
  document.documentElement.removeChild(testElement);
  return dimensions;
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _media = _interopRequireDefault(__webpack_require__(38));

var _myCars = _interopRequireDefault(__webpack_require__(40));

var _widgetInfo = _interopRequireDefault(__webpack_require__(42));

var _modalSettings = _interopRequireDefault(__webpack_require__(39));

var _renderSettings = _interopRequireDefault(__webpack_require__(41));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  media: _media.default,
  myCars: _myCars.default,
  widgetInfo: _widgetInfo.default,
  modalSettings: _modalSettings.default,
  renderSettings: _renderSettings.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = media;

var _types = __webpack_require__(3);

function media() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    images: [],
    videoOrder: [],
    videos: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_MEDIA:
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modalSettings;

var _types = __webpack_require__(3);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function modalSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    persistIndex: true
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    var newProps = action.payload;

    switch (action.type) {
      case _types.SET_MODAL_SETTINGS:
        {
          return _objectSpread({}, state, newProps);
        }
      // no default
    }
  }

  return state;
}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = myCars;

var _types = __webpack_require__(3);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function myCars() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    enabled: false,
    savedVehicles: null
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_MY_CARS_SAVED:
        return _objectSpread({}, state, {
          savedVehicles: action.payload
        });

      case _types.SET_MY_CARS_ENABLED:
        return _objectSpread({}, state, {
          enabled: action.payload
        });
      // no default
    }
  }

  return state;
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderSettings;

var _types = __webpack_require__(3);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function renderSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    var newProps = action.payload;

    switch (action.type) {
      case _types.SET_RENDER_SETTINGS:
        {
          return _objectSpread({}, state, newProps);
        }
      // no default
    }
  }

  return state;
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = widgetInfo;

var _types = __webpack_require__(3);

function widgetInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_WIDGET_INFO:
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(78);

var _reduxThunk = _interopRequireDefault(__webpack_require__(79));

var _reducers = _interopRequireDefault(__webpack_require__(37));

var _requestData = _interopRequireDefault(__webpack_require__(48));

var _prefs = _interopRequireDefault(__webpack_require__(47));

var _labels = _interopRequireDefault(__webpack_require__(46));

var _sitemap = _interopRequireDefault(__webpack_require__(49));

var _flags = _interopRequireDefault(__webpack_require__(45));

var _middleware = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-vehicle-media - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(75),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetComponents = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(14);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(44));

var _Collapse = _interopRequireDefault(__webpack_require__(43));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var getWidgetComponents = function getWidgetComponents(Widget, store, widgetId) {
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;
  return _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(Widget, null))));
};

exports.getWidgetComponents = getWidgetComponents;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(13);

var emptyObject = __webpack_require__(61);
var _invariant = __webpack_require__(62);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

/**
 * lodash 3.7.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseGet;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.8.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(66);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

module.exports = toPath;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.7.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseGet = __webpack_require__(63),
    toPath = __webpack_require__(64);

/**
 * Gets the property value of `path` on `object`. If the resolved value is
 * `undefined` the `defaultValue` is used in its place.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTweenState = __webpack_require__(74);

var _reactTweenState2 = _interopRequireDefault(_reactTweenState);

var _decorators = __webpack_require__(68);

var _decorators2 = _interopRequireDefault(_decorators);

var _objectAssign = __webpack_require__(13);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _exenv = __webpack_require__(53);

var _exenv2 = _interopRequireDefault(_exenv);

var _createReactClass = __webpack_require__(10);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addEvent = function addEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.addEventListener) {
    elem.addEventListener(type, eventHandle, false);
  } else if (elem.attachEvent) {
    elem.attachEvent('on' + type, eventHandle);
  } else {
    elem['on' + type] = eventHandle;
  }
};

var removeEvent = function removeEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.removeEventListener) {
    elem.removeEventListener(type, eventHandle, false);
  } else if (elem.detachEvent) {
    elem.detachEvent('on' + type, eventHandle);
  } else {
    elem['on' + type] = null;
  }
};

var Carousel = (0, _createReactClass2.default)({
  displayName: 'Carousel',

  mixins: [_reactTweenState2.default.Mixin],

  propTypes: {
    afterSlide: _propTypes2.default.func,
    autoplay: _propTypes2.default.bool,
    autoplayInterval: _propTypes2.default.number,
    beforeSlide: _propTypes2.default.func,
    cellAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
    cellSpacing: _propTypes2.default.number,
    data: _propTypes2.default.func,
    decorators: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      component: _propTypes2.default.func,
      position: _propTypes2.default.oneOf(['TopLeft', 'TopCenter', 'TopRight', 'CenterLeft', 'CenterCenter', 'CenterRight', 'BottomLeft', 'BottomCenter', 'BottomRight']),
      style: _propTypes2.default.object
    })),
    dragging: _propTypes2.default.bool,
    easing: _propTypes2.default.string,
    edgeEasing: _propTypes2.default.string,
    framePadding: _propTypes2.default.string,
    frameOverflow: _propTypes2.default.string,
    heightMode: _propTypes2.default.oneOf(['first', 'max', 'current']),
    initialSlideHeight: _propTypes2.default.number,
    initialSlideWidth: _propTypes2.default.number,
    onResize: _propTypes2.default.func,
    shouldRecalculateHeight: _propTypes2.default.bool,
    slideIndex: _propTypes2.default.number,
    slidesToShow: _propTypes2.default.number,
    slidesToScroll: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
    slideWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    speed: _propTypes2.default.number,
    swiping: _propTypes2.default.bool,
    vertical: _propTypes2.default.bool,
    width: _propTypes2.default.string,
    wrapAround: _propTypes2.default.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      afterSlide: function afterSlide() {},
      autoplay: false,
      autoplayInterval: 3000,
      beforeSlide: function beforeSlide() {},
      cellAlign: 'left',
      cellSpacing: 0,
      data: function data() {},
      decorators: _decorators2.default,
      dragging: true,
      easing: 'easeOutCirc',
      edgeEasing: 'easeOutElastic',
      framePadding: '0px',
      frameOverflow: 'hidden',
      heightMode: 'first',
      onResize: function onResize() {},
      shouldRecalculateHeight: false,
      slideIndex: 0,
      slidesToScroll: 1,
      slidesToShow: 1,
      slideWidth: 1,
      speed: 500,
      swiping: true,
      vertical: false,
      width: '100%',
      wrapAround: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      currentSlide: this.props.slideIndex,
      dragging: false,
      frameWidth: 0,
      left: 0,
      slideCount: 0,
      slidesToScroll: this.props.slidesToScroll,
      slideWidth: 0,
      top: 0
    };
  },
  componentWillMount: function componentWillMount() {
    this.setInitialDimensions();
  },
  componentDidMount: function componentDidMount() {
    // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
    this.mounted = true;
    this.setDimensions();
    this.bindEvents();
    this.setExternalData();
    if (this.props.autoplay) {
      this.startAutoplay();
    }
  },
  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
    if (nextProps.shouldRecalculateHeight) {
      var height = this.state.slideHeight;
      var childNodes = this.refs.frame.childNodes[0].childNodes;
      if (nextProps.heightMode === 'max') {
        height = this.findMaxHeightSlide(childNodes);
      }
      if (nextProps.heightMode === 'current') {
        height = childNodes[this.state.currentSlide].offsetHeight;
      }
      if (nextProps.heightMode === 'first') {
        height = childNodes[0].offsetHeight;
      }
      if (this.state.slideHeight !== height) {
        this.setDimensions(nextProps);
      }
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState({
      slideCount: nextProps.children.length
    });
    this.setDimensions(nextProps);
    if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide) {
      this.goToSlide(nextProps.slideIndex);
    }
    if (this.props.autoplay !== nextProps.autoplay) {
      if (nextProps.autoplay) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.unbindEvents();
    this.stopAutoplay();
    // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
    this.mounted = false;
  },
  render: function render() {
    var self = this;
    var children = _react2.default.Children.count(this.props.children) > 1 ? this.formatChildren(this.props.children) : this.props.children;
    return _react2.default.createElement(
      'div',
      {
        className: ['slider', this.props.className || ''].join(' '),
        ref: 'slider',
        style: (0, _objectAssign2.default)(this.getSliderStyles(), this.props.style || {})
      },
      _react2.default.createElement(
        'div',
        _extends({
          className: 'slider-frame',
          ref: 'frame',
          style: this.getFrameStyles()
        }, this.getTouchEvents(), this.getMouseEvents(), {
          onClick: this.handleClick
        }),
        _react2.default.createElement(
          'ul',
          { className: 'slider-list', ref: 'list', style: this.getListStyles() },
          children
        )
      ),
      this.props.decorators ? this.props.decorators.map(function (Decorator, index) {
        return _react2.default.createElement(
          'div',
          {
            style: (0, _objectAssign2.default)(self.getDecoratorStyles(Decorator.position), Decorator.style || {}),
            className: 'slider-decorator-' + index,
            key: index
          },
          _react2.default.createElement(Decorator.component, {
            currentSlide: self.state.currentSlide,
            slideCount: self.state.slideCount,
            frameWidth: self.state.frameWidth,
            slideWidth: self.state.slideWidth,
            slidesToScroll: self.state.slidesToScroll,
            cellSpacing: self.props.cellSpacing,
            slidesToShow: self.props.slidesToShow,
            wrapAround: self.props.wrapAround,
            nextSlide: self.nextSlide,
            previousSlide: self.previousSlide,
            goToSlide: self.goToSlide
          })
        );
      }) : null,
      _react2.default.createElement('style', {
        type: 'text/css',
        dangerouslySetInnerHTML: { __html: self.getStyleTagStyles() }
      })
    );
  },


  // Touch Events

  touchObject: {},

  getTouchEvents: function getTouchEvents() {
    var self = this;

    if (self.props.swiping === false) {
      return null;
    }

    return {
      onTouchStart: function onTouchStart(e) {
        self.touchObject = {
          startX: e.touches[0].pageX,
          startY: e.touches[0].pageY
        };
        self.handleMouseOver();
      },
      onTouchMove: function onTouchMove(e) {
        var direction = self.swipeDirection(self.touchObject.startX, e.touches[0].pageX, self.touchObject.startY, e.touches[0].pageY);

        if (direction !== 0) {
          e.preventDefault();
        }

        var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - self.touchObject.startX, 2)));

        self.touchObject = {
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
          endX: e.touches[0].pageX,
          endY: e.touches[0].pageY,
          length: length,
          direction: direction
        };

        self.setState({
          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
        });
      },
      onTouchEnd: function onTouchEnd(e) {
        self.handleSwipe(e);
        self.handleMouseOut();
      },
      onTouchCancel: function onTouchCancel(e) {
        self.handleSwipe(e);
      }
    };
  },


  clickSafe: true,

  getMouseEvents: function getMouseEvents() {
    var self = this;

    if (this.props.dragging === false) {
      return null;
    }

    return {
      onMouseOver: function onMouseOver() {
        self.handleMouseOver();
      },
      onMouseOut: function onMouseOut() {
        self.handleMouseOut();
      },
      onMouseDown: function onMouseDown(e) {
        self.touchObject = {
          startX: e.clientX,
          startY: e.clientY
        };

        self.setState({
          dragging: true
        });
      },
      onMouseMove: function onMouseMove(e) {
        if (!self.state.dragging) {
          return;
        }

        var direction = self.swipeDirection(self.touchObject.startX, e.clientX, self.touchObject.startY, e.clientY);

        if (direction !== 0) {
          e.preventDefault();
        }

        var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - self.touchObject.startX, 2)));

        self.touchObject = {
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
          endX: e.clientX,
          endY: e.clientY,
          length: length,
          direction: direction
        };

        self.setState({
          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
        });
      },
      onMouseUp: function onMouseUp(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      },
      onMouseLeave: function onMouseLeave(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      }
    };
  },
  handleMouseOver: function handleMouseOver() {
    if (this.props.autoplay) {
      this.autoplayPaused = true;
      this.stopAutoplay();
    }
  },
  handleMouseOut: function handleMouseOut() {
    if (this.props.autoplay && this.autoplayPaused) {
      this.startAutoplay();
      this.autoplayPaused = null;
    }
  },
  handleClick: function handleClick(e) {
    if (this.clickSafe === true) {
      e.preventDefault();
      e.stopPropagation();

      if (e.nativeEvent) {
        e.nativeEvent.stopPropagation();
      }
    }
  },
  handleSwipe: function handleSwipe(e) {
    if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
      this.clickSafe = true;
    } else {
      this.clickSafe = false;
    }

    var slidesToShow = this.props.slidesToShow;
    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = this.state.slidesToScroll;
    }

    if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
      if (this.touchObject.direction === 1) {
        if (this.state.currentSlide >= _react2.default.Children.count(this.props.children) - slidesToShow && !this.props.wrapAround) {
          this.animateSlide(_reactTweenState2.default.easingTypes[this.props.edgeEasing]);
        } else {
          this.nextSlide();
        }
      } else if (this.touchObject.direction === -1) {
        if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
          this.animateSlide(_reactTweenState2.default.easingTypes[this.props.edgeEasing]);
        } else {
          this.previousSlide();
        }
      }
    } else {
      this.goToSlide(this.state.currentSlide);
    }

    this.touchObject = {};

    this.setState({
      dragging: false
    });
  },
  swipeDirection: function swipeDirection(x1, x2, y1, y2) {
    var xDist, yDist, r, swipeAngle;

    xDist = x1 - x2;
    yDist = y1 - y2;
    r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return 1;
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return 1;
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return -1;
    }
    if (this.props.vertical === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 1;
      } else {
        return -1;
      }
    }
    return 0;
  },
  autoplayIterator: function autoplayIterator() {
    if (this.props.wrapAround) {
      return this.nextSlide();
    }
    if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
      this.nextSlide();
    } else {
      this.stopAutoplay();
    }
  },
  startAutoplay: function startAutoplay() {
    this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
  },
  resetAutoplay: function resetAutoplay() {
    if (this.props.autoplay && !this.autoplayPaused) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  },
  stopAutoplay: function stopAutoplay() {
    this.autoplayID && clearInterval(this.autoplayID);
  },


  // Action Methods

  goToSlide: function goToSlide(index) {
    var self = this;
    if (index >= _react2.default.Children.count(this.props.children) || index < 0) {
      if (!this.props.wrapAround) {
        return;
      }
      if (index >= _react2.default.Children.count(this.props.children)) {
        this.props.beforeSlide(this.state.currentSlide, 0);
        return this.setState({
          currentSlide: 0
        }, function () {
          self.animateSlide(null, null, self.getTargetLeft(null, index), function () {
            self.animateSlide(null, 0.01);
            self.props.afterSlide(0);
            self.resetAutoplay();
            self.setExternalData();
          });
        });
      } else {
        var endSlide = _react2.default.Children.count(this.props.children) - this.state.slidesToScroll;
        this.props.beforeSlide(this.state.currentSlide, endSlide);
        return this.setState({
          currentSlide: endSlide
        }, function () {
          self.animateSlide(null, null, self.getTargetLeft(null, index), function () {
            self.animateSlide(null, 0.01);
            self.props.afterSlide(endSlide);
            self.resetAutoplay();
            self.setExternalData();
          });
        });
      }
    }

    this.props.beforeSlide(this.state.currentSlide, index);

    if (index !== this.state.currentSlide) {
      this.props.afterSlide(index);
    }
    this.setState({
      currentSlide: index
    }, function () {
      self.animateSlide();
      self.resetAutoplay();
      self.setExternalData();
      self.setDimensions(this.props);
    });
  },
  nextSlide: function nextSlide() {
    var childrenCount = _react2.default.Children.count(this.props.children);
    var slidesToShow = this.props.slidesToShow;
    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = this.state.slidesToScroll;
    }
    if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround) {
      return;
    }

    if (this.props.wrapAround) {
      this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
    } else {
      if (this.props.slideWidth !== 1) {
        return this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
      }
      this.goToSlide(Math.min(this.state.currentSlide + this.state.slidesToScroll, childrenCount - slidesToShow));
    }
  },
  previousSlide: function previousSlide() {
    if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
      return;
    }

    if (this.props.wrapAround) {
      this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
    } else {
      this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
    }
  },


  // Animation

  animateSlide: function animateSlide(easing, duration, endValue, callback) {
    this.tweenState(this.props.vertical ? 'top' : 'left', {
      easing: easing || _reactTweenState2.default.easingTypes[this.props.easing],
      duration: duration || this.props.speed,
      endValue: endValue || this.getTargetLeft(),
      onEnd: callback || null
    });
  },
  getTargetLeft: function getTargetLeft(touchOffset, slide) {
    var offset;
    var target = slide || this.state.currentSlide;
    switch (this.props.cellAlign) {
      case 'left':
        {
          offset = 0;
          offset -= this.props.cellSpacing * target;
          break;
        }
      case 'center':
        {
          offset = (this.state.frameWidth - this.state.slideWidth) / 2;
          offset -= this.props.cellSpacing * target;
          break;
        }
      case 'right':
        {
          offset = this.state.frameWidth - this.state.slideWidth;
          offset -= this.props.cellSpacing * target;
          break;
        }
    }

    var left = this.state.slideWidth * target;

    var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;

    if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
      left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
      offset = 0;
      offset -= this.props.cellSpacing * (this.state.slideCount - 1);
    }

    offset -= touchOffset || 0;

    return (left - offset) * -1;
  },


  // Bootstrapping

  bindEvents: function bindEvents() {
    var self = this;
    if (_exenv2.default.canUseDOM) {
      addEvent(window, 'resize', self.onResize);
      addEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },
  onResize: function onResize() {
    this.setDimensions(null, this.props.onResize);
  },
  onReadyStateChange: function onReadyStateChange() {
    this.setDimensions();
  },
  unbindEvents: function unbindEvents() {
    var self = this;
    if (_exenv2.default.canUseDOM) {
      removeEvent(window, 'resize', self.onResize);
      removeEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },
  formatChildren: function formatChildren(children) {
    var self = this;
    var positionValue = this.props.vertical ? this.getTweeningValue('top') : this.getTweeningValue('left');
    return _react2.default.Children.map(children, function (child, index) {
      return _react2.default.createElement(
        'li',
        {
          className: 'slider-slide',
          style: self.getSlideStyles(index, positionValue),
          key: index
        },
        child
      );
    });
  },
  setInitialDimensions: function setInitialDimensions() {
    var self = this,
        slideWidth,
        frameHeight,
        slideHeight;

    slideWidth = this.props.vertical ? this.props.initialSlideHeight || 0 : this.props.initialSlideWidth || 0;
    slideHeight = this.props.initialSlideHeight ? this.props.initialSlideHeight * this.props.slidesToShow : 0;

    frameHeight = slideHeight + this.props.cellSpacing * (this.props.slidesToShow - 1);

    this.setState({
      slideHeight: slideHeight,
      frameWidth: this.props.vertical ? frameHeight : '100%',
      slideCount: _react2.default.Children.count(this.props.children),
      slideWidth: slideWidth
    }, function () {
      self.setLeft();
      self.setExternalData();
    });
  },
  findMaxHeightSlide: function findMaxHeightSlide(slides) {
    var maxHeight = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].offsetHeight > maxHeight) {
        maxHeight = slides[i].offsetHeight;
      }
    }
    return maxHeight;
  },
  setDimensions: function setDimensions(props) {
    var stateCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    props = props || this.props;

    var self = this,
        slideWidth,
        slidesToScroll,
        firstSlide,
        frame,
        frameWidth,
        frameHeight,
        slideHeight,
        childNodes;

    slidesToScroll = props.slidesToScroll;
    frame = this.refs.frame;
    childNodes = frame.childNodes[0].childNodes;
    firstSlide = childNodes[0];
    if (firstSlide) {
      firstSlide.style.height = 'auto';
      slideHeight = this.props.vertical ? firstSlide.offsetHeight * props.slidesToShow : firstSlide.offsetHeight;
      if (props.heightMode === 'max') {
        slideHeight = this.findMaxHeightSlide(childNodes);
      }
    } else {
      slideHeight = 100;
    }

    if (props.heightMode === 'current') {
      slideHeight = childNodes[this.state.currentSlide].offsetHeight;
    }

    if (typeof props.slideWidth !== 'number') {
      slideWidth = parseInt(props.slideWidth);
    } else {
      if (props.vertical) {
        slideWidth = slideHeight / props.slidesToShow * props.slideWidth;
      } else {
        slideWidth = frame.offsetWidth / props.slidesToShow * props.slideWidth;
      }
    }

    if (!props.vertical) {
      slideWidth -= props.cellSpacing * ((100 - 100 / props.slidesToShow) / 100);
    }

    frameHeight = slideHeight + props.cellSpacing * (props.slidesToShow - 1);
    frameWidth = props.vertical ? frameHeight : frame.offsetWidth;

    if (props.slidesToScroll === 'auto') {
      slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
    }

    this.setState({
      slideHeight: slideHeight,
      frameWidth: frameWidth,
      slideWidth: slideWidth,
      slidesToScroll: slidesToScroll,
      left: props.vertical ? 0 : this.getTargetLeft(),
      top: props.vertical ? this.getTargetLeft() : 0
    }, function () {
      stateCb();
      self.setLeft();
    });
  },
  setLeft: function setLeft() {
    this.setState({
      left: this.props.vertical ? 0 : this.getTargetLeft(),
      top: this.props.vertical ? this.getTargetLeft() : 0
    });
  },


  // Data

  setExternalData: function setExternalData() {
    if (this.props.data) {
      this.props.data();
    }
  },


  // Styles

  getListStyles: function getListStyles() {
    var listWidth = this.state.slideWidth * _react2.default.Children.count(this.props.children);
    var spacingOffset = this.props.cellSpacing * _react2.default.Children.count(this.props.children);
    var transform = 'translate3d(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px, 0)';
    return {
      transform: transform,
      WebkitTransform: transform,
      msTransform: 'translate(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px)',
      position: 'relative',
      display: 'block',
      margin: this.props.vertical ? this.props.cellSpacing / 2 * -1 + 'px 0px' : '0px ' + this.props.cellSpacing / 2 * -1 + 'px',
      padding: 0,
      height: this.props.vertical ? listWidth + spacingOffset : this.state.slideHeight,
      width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
      cursor: this.state.dragging === true ? 'pointer' : 'inherit',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box'
    };
  },
  getFrameStyles: function getFrameStyles() {
    return {
      position: 'relative',
      display: 'block',
      overflow: this.props.frameOverflow,
      height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
      margin: this.props.framePadding,
      padding: 0,
      transform: 'translate3d(0, 0, 0)',
      WebkitTransform: 'translate3d(0, 0, 0)',
      msTransform: 'translate(0, 0)',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box'
    };
  },
  getSlideStyles: function getSlideStyles(index, positionValue) {
    var targetPosition = this.getSlideTargetPosition(index, positionValue);
    return {
      position: 'absolute',
      left: this.props.vertical ? 0 : targetPosition,
      top: this.props.vertical ? targetPosition : 0,
      display: this.props.vertical ? 'block' : 'inline-block',
      listStyleType: 'none',
      verticalAlign: 'top',
      width: this.props.vertical ? '100%' : this.state.slideWidth,
      height: 'auto',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
      marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto'
    };
  },
  getSlideTargetPosition: function getSlideTargetPosition(index, positionValue) {
    var slidesToShow = this.state.frameWidth / this.state.slideWidth;
    var targetPosition = (this.state.slideWidth + this.props.cellSpacing) * index;
    var end = (this.state.slideWidth + this.props.cellSpacing) * slidesToShow * -1;

    if (this.props.wrapAround) {
      var slidesBefore = Math.ceil(positionValue / this.state.slideWidth);
      if (this.state.slideCount - slidesBefore <= index) {
        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount - index) * -1;
      }

      var slidesAfter = Math.ceil((Math.abs(positionValue) - Math.abs(end)) / this.state.slideWidth);

      if (this.state.slideWidth !== 1) {
        slidesAfter = Math.ceil((Math.abs(positionValue) - this.state.slideWidth) / this.state.slideWidth);
      }

      if (index <= slidesAfter - 1) {
        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount + index);
      }
    }

    return targetPosition;
  },
  getSliderStyles: function getSliderStyles() {
    return {
      position: 'relative',
      display: 'block',
      width: this.props.width,
      height: 'auto',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      visibility: this.state.slideWidth ? 'visible' : 'hidden'
    };
  },
  getStyleTagStyles: function getStyleTagStyles() {
    return '.slider-slide > img {width: 100%; display: block;}';
  },
  getDecoratorStyles: function getDecoratorStyles(position) {
    switch (position) {
      case 'TopLeft':
        {
          return {
            position: 'absolute',
            top: 0,
            left: 0
          };
        }
      case 'TopCenter':
        {
          return {
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            WebkitTransform: 'translateX(-50%)',
            msTransform: 'translateX(-50%)'
          };
        }
      case 'TopRight':
        {
          return {
            position: 'absolute',
            top: 0,
            right: 0
          };
        }
      case 'CenterLeft':
        {
          return {
            position: 'absolute',
            top: '50%',
            left: 0,
            transform: 'translateY(-50%)',
            WebkitTransform: 'translateY(-50%)',
            msTransform: 'translateY(-50%)'
          };
        }
      case 'CenterCenter':
        {
          return {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            WebkitTransform: 'translate(-50%, -50%)',
            msTransform: 'translate(-50%, -50%)'
          };
        }
      case 'CenterRight':
        {
          return {
            position: 'absolute',
            top: '50%',
            right: 0,
            transform: 'translateY(-50%)',
            WebkitTransform: 'translateY(-50%)',
            msTransform: 'translateY(-50%)'
          };
        }
      case 'BottomLeft':
        {
          return {
            position: 'absolute',
            bottom: 0,
            left: 0
          };
        }
      case 'BottomCenter':
        {
          return {
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            WebkitTransform: 'translateX(-50%)',
            msTransform: 'translateX(-50%)'
          };
        }
      case 'BottomRight':
        {
          return {
            position: 'absolute',
            bottom: 0,
            right: 0
          };
        }
      default:
        {
          return {
            position: 'absolute',
            top: 0,
            left: 0
          };
        }
    }
  }
});

Carousel.ControllerMixin = {
  getInitialState: function getInitialState() {
    return {
      carousels: {}
    };
  },
  setCarouselData: function setCarouselData(carousel) {
    var data = this.state.carousels;
    data[carousel] = this.refs[carousel];
    this.setState({
      carousels: data
    });
  }
};

exports.default = Carousel;
module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(10);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultDecorators = [{
  component: (0, _createReactClass2.default)({
    displayName: 'component',
    render: function render() {
      return _react2.default.createElement(
        'button',
        {
          style: this.getButtonStyles(this.props.currentSlide === 0 && !this.props.wrapAround),
          onClick: this.handleClick },
        'PREV'
      );
    },
    handleClick: function handleClick(e) {
      e.preventDefault();
      this.props.previousSlide();
    },
    getButtonStyles: function getButtonStyles(disabled) {
      return {
        border: 0,
        background: 'rgba(0,0,0,0.4)',
        color: 'white',
        padding: 10,
        outline: 0,
        opacity: disabled ? 0.3 : 1,
        cursor: 'pointer'
      };
    }
  }),
  position: 'CenterLeft'
}, {
  component: (0, _createReactClass2.default)({
    displayName: 'component',
    render: function render() {
      return _react2.default.createElement(
        'button',
        {
          style: this.getButtonStyles(this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround),
          onClick: this.handleClick },
        'NEXT'
      );
    },
    handleClick: function handleClick(e) {
      e.preventDefault();
      this.props.nextSlide();
    },
    getButtonStyles: function getButtonStyles(disabled) {
      return {
        border: 0,
        background: 'rgba(0,0,0,0.4)',
        color: 'white',
        padding: 10,
        outline: 0,
        opacity: disabled ? 0.3 : 1,
        cursor: 'pointer'
      };
    }
  }),
  position: 'CenterRight'
}, {
  component: (0, _createReactClass2.default)({
    displayName: 'component',
    render: function render() {
      var self = this;
      var indexes = this.getIndexes(self.props.slideCount, self.props.slidesToScroll);
      return _react2.default.createElement(
        'ul',
        { style: self.getListStyles() },
        indexes.map(function (index) {
          return _react2.default.createElement(
            'li',
            { style: self.getListItemStyles(), key: index },
            _react2.default.createElement(
              'button',
              {
                style: self.getButtonStyles(self.props.currentSlide === index),
                onClick: self.props.goToSlide.bind(null, index) },
              '\u2022'
            )
          );
        })
      );
    },
    getIndexes: function getIndexes(count, inc) {
      var arr = [];
      for (var i = 0; i < count; i += inc) {
        arr.push(i);
      }
      return arr;
    },
    getListStyles: function getListStyles() {
      return {
        position: 'relative',
        margin: 0,
        top: -10,
        padding: 0
      };
    },
    getListItemStyles: function getListItemStyles() {
      return {
        listStyleType: 'none',
        display: 'inline-block'
      };
    },
    getButtonStyles: function getButtonStyles(active) {
      return {
        border: 0,
        background: 'transparent',
        color: 'black',
        cursor: 'pointer',
        padding: 10,
        outline: 0,
        fontSize: 24,
        opacity: active ? 1 : 0.5
      };
    }
  }),
  position: 'BottomCenter'
}];

exports.default = DefaultDecorators;
module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(72)


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(71);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(73);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(70);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.tweenState=n():e.tweenState=n()}(this,function(){return function(e){function n(r){if(t[r])return t[r].exports;var a=t[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,n),a.loaded=!0,a.exports}var t={};return n.m=e,n.c=t,n.p="",n(0)}({0:function(e,n,t){e.exports=t(90)},1:function(e,n){function t(){c=!1,o.length?s=o.concat(s):f=-1,s.length&&r()}function r(){if(!c){var e=setTimeout(t);c=!0;for(var n=s.length;n;){for(o=s,s=[];++f<n;)o&&o[f].run();f=-1,n=s.length}o=null,c=!1,clearTimeout(e)}}function a(e,n){this.fun=e,this.array=n}function u(){}var o,i=e.exports={},s=[],c=!1,f=-1;i.nextTick=function(e){var n=new Array(arguments.length-1);if(arguments.length>1)for(var t=1;t<arguments.length;t++)n[t-1]=arguments[t];s.push(new a(e,n)),1!==s.length||c||setTimeout(r,0)},a.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=u,i.addListener=u,i.once=u,i.off=u,i.removeListener=u,i.removeAllListeners=u,i.emit=u,i.binding=function(e){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(e){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},90:function(e,n,t){"use strict";function r(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(n,"__esModule",{value:!0});var a=t(165),u=r(a),o=t(91),i=r(o),s="ADDITIVE",c=a.easeInOutQuad,f=300,l=0,h={ADDITIVE:"ADDITIVE",DESTRUCTIVE:"DESTRUCTIVE"},v={_rafID:null,getInitialState:function(){return{tweenQueue:[]}},componentWillUnmount:function(){i["default"].cancel(this._rafID),this._rafID=-1},tweenState:function(e,n){var t=this,r=n.easing,a=n.duration,u=n.delay,o=n.beginValue,v=n.endValue,d=n.onEnd,p=n.stackBehavior;this.setState(function(n){var I=n,w=void 0,g=void 0;if("string"==typeof e)w=e,g=e;else{for(var M=0;M<e.length-1;M++)I=I[e[M]];w=e[e.length-1],g=e.join("|")}var m={easing:r||c,duration:null==a?f:a,delay:null==u?l:u,beginValue:null==o?I[w]:o,endValue:v,onEnd:d,stackBehavior:p||s},x=n.tweenQueue;return m.stackBehavior===h.DESTRUCTIVE&&(x=n.tweenQueue.filter(function(e){return e.pathHash!==g})),x.push({pathHash:g,config:m,initTime:Date.now()+m.delay}),I[w]=m.endValue,1===x.length&&(t._rafID=(0,i["default"])(t._rafCb)),{tweenQueue:x}})},getTweeningValue:function(e){var n=this.state,t=void 0,r=void 0;if("string"==typeof e)t=n[e],r=e;else{t=n;for(var a=0;a<e.length;a++)t=t[e[a]];r=e.join("|")}for(var u=Date.now(),a=0;a<n.tweenQueue.length;a++){var o=n.tweenQueue[a],i=o.pathHash,s=o.initTime,c=o.config;if(i===r){var f=u-s>c.duration?c.duration:Math.max(0,u-s),l=0===c.duration?c.endValue:c.easing(f,c.beginValue,c.endValue,c.duration),h=l-c.endValue;t+=h}}return t},_rafCb:function(){var e=this.state;if(0!==e.tweenQueue.length){for(var n=Date.now(),t=[],r=0;r<e.tweenQueue.length;r++){var a=e.tweenQueue[r],u=a.initTime,o=a.config;n-u<o.duration?t.push(a):o.onEnd&&o.onEnd()}-1!==this._rafID&&(this.setState({tweenQueue:t}),this._rafID=(0,i["default"])(this._rafCb))}}};n["default"]={Mixin:v,easingTypes:u["default"],stackBehavior:h},e.exports=n["default"]},91:function(e,n,t){for(var r=t(92),a="undefined"==typeof window?{}:window,u=["moz","webkit"],o="AnimationFrame",i=a["request"+o],s=a["cancel"+o]||a["cancelRequest"+o],c=0;c<u.length&&!i;c++)i=a[u[c]+"Request"+o],s=a[u[c]+"Cancel"+o]||a[u[c]+"CancelRequest"+o];if(!i||!s){var f=0,l=0,h=[],v=1e3/60;i=function(e){if(0===h.length){var n=r(),t=Math.max(0,v-(n-f));f=t+n,setTimeout(function(){var e=h.slice(0);h.length=0;for(var n=0;n<e.length;n++)if(!e[n].cancelled)try{e[n].callback(f)}catch(t){setTimeout(function(){throw t},0)}},Math.round(t))}return h.push({handle:++l,callback:e,cancelled:!1}),l},s=function(e){for(var n=0;n<h.length;n++)h[n].handle===e&&(h[n].cancelled=!0)}}e.exports=function(e){return i.call(a,e)},e.exports.cancel=function(){s.apply(a,arguments)}},92:function(e,n,t){(function(n){(function(){var t,r,a;"undefined"!=typeof performance&&null!==performance&&performance.now?e.exports=function(){return performance.now()}:"undefined"!=typeof n&&null!==n&&n.hrtime?(e.exports=function(){return(t()-a)/1e6},r=n.hrtime,t=function(){var e;return e=r(),1e9*e[0]+e[1]},a=t()):Date.now?(e.exports=function(){return Date.now()-a},a=Date.now()):(e.exports=function(){return(new Date).getTime()-a},a=(new Date).getTime())}).call(this)}).call(n,t(1))},165:function(e,n){"use strict";var t={linear:function(e,n,t,r){var a=t-n;return a*e/r+n},easeInQuad:function(e,n,t,r){var a=t-n;return a*(e/=r)*e+n},easeOutQuad:function(e,n,t,r){var a=t-n;return-a*(e/=r)*(e-2)+n},easeInOutQuad:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?a/2*e*e+n:-a/2*(--e*(e-2)-1)+n},easeInCubic:function(e,n,t,r){var a=t-n;return a*(e/=r)*e*e+n},easeOutCubic:function(e,n,t,r){var a=t-n;return a*((e=e/r-1)*e*e+1)+n},easeInOutCubic:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?a/2*e*e*e+n:a/2*((e-=2)*e*e+2)+n},easeInQuart:function(e,n,t,r){var a=t-n;return a*(e/=r)*e*e*e+n},easeOutQuart:function(e,n,t,r){var a=t-n;return-a*((e=e/r-1)*e*e*e-1)+n},easeInOutQuart:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?a/2*e*e*e*e+n:-a/2*((e-=2)*e*e*e-2)+n},easeInQuint:function(e,n,t,r){var a=t-n;return a*(e/=r)*e*e*e*e+n},easeOutQuint:function(e,n,t,r){var a=t-n;return a*((e=e/r-1)*e*e*e*e+1)+n},easeInOutQuint:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?a/2*e*e*e*e*e+n:a/2*((e-=2)*e*e*e*e+2)+n},easeInSine:function(e,n,t,r){var a=t-n;return-a*Math.cos(e/r*(Math.PI/2))+a+n},easeOutSine:function(e,n,t,r){var a=t-n;return a*Math.sin(e/r*(Math.PI/2))+n},easeInOutSine:function(e,n,t,r){var a=t-n;return-a/2*(Math.cos(Math.PI*e/r)-1)+n},easeInExpo:function(e,n,t,r){var a=t-n;return 0==e?n:a*Math.pow(2,10*(e/r-1))+n},easeOutExpo:function(e,n,t,r){var a=t-n;return e==r?n+a:a*(-Math.pow(2,-10*e/r)+1)+n},easeInOutExpo:function(e,n,t,r){var a=t-n;return 0===e?n:e===r?n+a:(e/=r/2)<1?a/2*Math.pow(2,10*(e-1))+n:a/2*(-Math.pow(2,-10*--e)+2)+n},easeInCirc:function(e,n,t,r){var a=t-n;return-a*(Math.sqrt(1-(e/=r)*e)-1)+n},easeOutCirc:function(e,n,t,r){var a=t-n;return a*Math.sqrt(1-(e=e/r-1)*e)+n},easeInOutCirc:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?-a/2*(Math.sqrt(1-e*e)-1)+n:a/2*(Math.sqrt(1-(e-=2)*e)+1)+n},easeInElastic:function(e,n,t,r){var a,u,o,i=t-n;return o=1.70158,u=0,a=i,0===e?n:1===(e/=r)?n+i:(u||(u=.3*r),a<Math.abs(i)?(a=i,o=u/4):o=u/(2*Math.PI)*Math.asin(i/a),-(a*Math.pow(2,10*(e-=1))*Math.sin((e*r-o)*(2*Math.PI)/u))+n)},easeOutElastic:function(e,n,t,r){var a,u,o,i=t-n;return o=1.70158,u=0,a=i,0===e?n:1===(e/=r)?n+i:(u||(u=.3*r),a<Math.abs(i)?(a=i,o=u/4):o=u/(2*Math.PI)*Math.asin(i/a),a*Math.pow(2,-10*e)*Math.sin((e*r-o)*(2*Math.PI)/u)+i+n)},easeInOutElastic:function(e,n,t,r){var a,u,o,i=t-n;return o=1.70158,u=0,a=i,0===e?n:2===(e/=r/2)?n+i:(u||(u=r*(.3*1.5)),a<Math.abs(i)?(a=i,o=u/4):o=u/(2*Math.PI)*Math.asin(i/a),1>e?-.5*(a*Math.pow(2,10*(e-=1))*Math.sin((e*r-o)*(2*Math.PI)/u))+n:a*Math.pow(2,-10*(e-=1))*Math.sin((e*r-o)*(2*Math.PI)/u)*.5+i+n)},easeInBack:function(e,n,t,r,a){var u=t-n;return void 0===a&&(a=1.70158),u*(e/=r)*e*((a+1)*e-a)+n},easeOutBack:function(e,n,t,r,a){var u=t-n;return void 0===a&&(a=1.70158),u*((e=e/r-1)*e*((a+1)*e+a)+1)+n},easeInOutBack:function(e,n,t,r,a){var u=t-n;return void 0===a&&(a=1.70158),(e/=r/2)<1?u/2*(e*e*(((a*=1.525)+1)*e-a))+n:u/2*((e-=2)*e*(((a*=1.525)+1)*e+a)+2)+n},easeInBounce:function(e,n,r,a){var u,o=r-n;return u=t.easeOutBounce(a-e,0,o,a),o-u+n},easeOutBounce:function(e,n,t,r){var a=t-n;return(e/=r)<1/2.75?a*(7.5625*e*e)+n:2/2.75>e?a*(7.5625*(e-=1.5/2.75)*e+.75)+n:2.5/2.75>e?a*(7.5625*(e-=2.25/2.75)*e+.9375)+n:a*(7.5625*(e-=2.625/2.75)*e+.984375)+n},easeInOutBounce:function(e,n,r,a){var u,o=r-n;return a/2>e?(u=t.easeInBounce(2*e,0,o,a),.5*u+n):(u=t.easeOutBounce(2*e-a,0,o,a),.5*u+.5*o+n)}};e.exports=t}})});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 76 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = DDC.WsmCommonData;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(15);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.44474b24f6e77c83a363.js